import {
  Vector3,
  Line3,
  BufferAttribute,
  Vector4,
  Vector2,
  BufferGeometry,
  Triangle,
  Matrix3,
  Sphere,
  ShaderMaterial,
  UniformsUtils,
  ShaderLib,
  Color,
  Texture,
  Mesh,
  SkinnedMesh,
  Matrix4,
  Box3,
  DoubleSide,
  Raycaster,
  Material,
  Ray,
  BackSide
} from "three";
function getCameraRay(_0x2b7ec0, _0x28fd4c, _0x368e9f, _0x117feb, _0x467fd6) {
  let _0x15284a = new Vector3(0x0, 0x0, -0x1);
  (_0x15284a["x"] = (_0x28fd4c / _0x117feb) * 0x2 - 0x1),
    (_0x15284a["y"] = -(_0x368e9f / _0x467fd6) * 0x2 + 0x1);
  var _0x1283fe = _0x15284a["clone"]();
  _0x1283fe["unproject"](_0x2b7ec0),
    (_0x15284a["z"] = 0x1),
    _0x15284a["unproject"](_0x2b7ec0);
  let _0x21427c = new Vector3()["subVectors"](_0x15284a, _0x1283fe);
  return _0x21427c["normalize"](), new Ray(_0x1283fe, _0x21427c);
}
class OBJMTLExporter {
  ["parse"](_0x4f782b, _0xa34bc0 = "") {
    let _0x3e6f4b = "",
      _0x29f90b = 0x0,
      _0x57b41a = 0x0,
      _0x5002e9 = 0x0,
      _0x573d45 = {};
    const _0x3adfac = new Vector3(),
      _0x2806a1 = new Color(),
      _0x63a886 = new Vector3(),
      _0x1789b1 = new Vector2(),
      _0x4f80a9 = [];
    if (_0xa34bc0 != "") _0x3e6f4b += "mtllib\x20" + _0xa34bc0 + ".mtl\x0a";
    function _0x373bdd(_0x4bd7d0) {
      let _0x503ff2 = 0x0,
        _0x39659f = 0x0,
        _0x33ecc2 = 0x0;
      const _0x10272f = _0x4bd7d0["geometry"],
        _0x940bd2 = new Matrix3();
      if (_0x10272f["isBufferGeometry"] !== !![])
        throw new Error(
          "OBJExporter:\x20Geometry\x20is\x20not\x20of\x20type\x20BufferGeometry."
        );
      const _0x4185c9 = _0x10272f["getAttribute"]("position"),
        _0x8b7f61 = _0x10272f["getAttribute"]("normal"),
        _0x2e0692 = _0x10272f["getAttribute"]("uv"),
        _0x49b03f = _0x10272f["getIndex"]();
      _0x3e6f4b += "o\x20" + _0x4bd7d0["name"] + "\x0a";
      if (_0x4bd7d0["material"] && _0x4bd7d0["material"]["name"])
        _0x3e6f4b += "usemtl\x20" + _0x4bd7d0["material"]["name"] + "\x0a";
      else
        _0x4bd7d0["material"] &&
          (_0x3e6f4b +=
            "usemtl\x20material" + _0x4bd7d0["material"]["id"] + "\x0a");
      if (_0x4bd7d0["material"])
        _0x573d45[_0x4bd7d0["material"]["id"]] = _0x4bd7d0["material"];
      if (_0x4185c9 !== undefined)
        for (
          let _0x4249f3 = 0x0, _0x18c9e2 = _0x4185c9["count"];
          _0x4249f3 < _0x18c9e2;
          _0x4249f3++, _0x503ff2++
        ) {
          (_0x3adfac["x"] = _0x4185c9["getX"](_0x4249f3)),
            (_0x3adfac["y"] = _0x4185c9["getY"](_0x4249f3)),
            (_0x3adfac["z"] = _0x4185c9["getZ"](_0x4249f3)),
            _0x3adfac["applyMatrix4"](_0x4bd7d0["matrixWorld"]),
            (_0x3e6f4b +=
              "v\x20" +
              _0x3adfac["x"] +
              "\x20" +
              _0x3adfac["y"] +
              "\x20" +
              _0x3adfac["z"] +
              "\x0a");
        }
      if (_0x2e0692 !== undefined)
        for (
          let _0x187ceb = 0x0, _0x3c23e9 = _0x2e0692["count"];
          _0x187ceb < _0x3c23e9;
          _0x187ceb++, _0x33ecc2++
        ) {
          (_0x1789b1["x"] = _0x2e0692["getX"](_0x187ceb)),
            (_0x1789b1["y"] = _0x2e0692["getY"](_0x187ceb)),
            (_0x3e6f4b +=
              "vt\x20" + _0x1789b1["x"] + "\x20" + _0x1789b1["y"] + "\x0a");
        }
      if (_0x8b7f61 !== undefined) {
        _0x940bd2["getNormalMatrix"](_0x4bd7d0["matrixWorld"]);
        for (
          let _0x3e1e90 = 0x0, _0x5454c2 = _0x8b7f61["count"];
          _0x3e1e90 < _0x5454c2;
          _0x3e1e90++, _0x39659f++
        ) {
          (_0x63a886["x"] = _0x8b7f61["getX"](_0x3e1e90)),
            (_0x63a886["y"] = _0x8b7f61["getY"](_0x3e1e90)),
            (_0x63a886["z"] = _0x8b7f61["getZ"](_0x3e1e90)),
            _0x63a886["applyMatrix3"](_0x940bd2)["normalize"](),
            (_0x3e6f4b +=
              "vn\x20" +
              _0x63a886["x"] +
              "\x20" +
              _0x63a886["y"] +
              "\x20" +
              _0x63a886["z"] +
              "\x0a");
        }
      }
      if (_0x49b03f !== null)
        for (
          let _0x2d8e7f = 0x0, _0xef9cc2 = _0x49b03f["count"];
          _0x2d8e7f < _0xef9cc2;
          _0x2d8e7f += 0x3
        ) {
          for (let _0x192712 = 0x0; _0x192712 < 0x3; _0x192712++) {
            const _0x5f939f = _0x49b03f["getX"](_0x2d8e7f + _0x192712) + 0x1;
            _0x4f80a9[_0x192712] =
              _0x29f90b +
              _0x5f939f +
              (_0x8b7f61 || _0x2e0692
                ? "/" +
                  (_0x2e0692 ? _0x57b41a + _0x5f939f : "") +
                  (_0x8b7f61 ? "/" + (_0x5002e9 + _0x5f939f) : "")
                : "");
          }
          _0x3e6f4b += "f\x20" + _0x4f80a9["join"]("\x20") + "\x0a";
        }
      else
        for (
          let _0x136679 = 0x0, _0x2f244f = _0x4185c9["count"];
          _0x136679 < _0x2f244f;
          _0x136679 += 0x3
        ) {
          for (let _0x118997 = 0x0; _0x118997 < 0x3; _0x118997++) {
            const _0x4eedfa = _0x136679 + _0x118997 + 0x1;
            _0x4f80a9[_0x118997] =
              _0x29f90b +
              _0x4eedfa +
              (_0x8b7f61 || _0x2e0692
                ? "/" +
                  (_0x2e0692 ? _0x57b41a + _0x4eedfa : "") +
                  (_0x8b7f61 ? "/" + (_0x5002e9 + _0x4eedfa) : "")
                : "");
          }
          _0x3e6f4b += "f\x20" + _0x4f80a9["join"]("\x20") + "\x0a";
        }
      (_0x29f90b += _0x503ff2),
        (_0x57b41a += _0x33ecc2),
        (_0x5002e9 += _0x39659f);
    }
    function _0x75176c(_0x3c3be3) {
      let _0x49a38c = 0x0;
      const _0x7a9262 = _0x3c3be3["geometry"],
        _0x1a8ecc = _0x3c3be3["type"];
      if (_0x7a9262["isBufferGeometry"] !== !![])
        throw new Error(
          "THREE.OBJExporter:\x20Geometry\x20is\x20not\x20of\x20type\x20THREE.BufferGeometry."
        );
      const _0x4351f8 = _0x7a9262["getAttribute"]("position");
      _0x3e6f4b += "o\x20" + _0x3c3be3["name"] + "\x0a";
      if (_0x4351f8 !== undefined)
        for (
          let _0x4130a3 = 0x0, _0x15f442 = _0x4351f8["count"];
          _0x4130a3 < _0x15f442;
          _0x4130a3++, _0x49a38c++
        ) {
          (_0x3adfac["x"] = _0x4351f8["getX"](_0x4130a3)),
            (_0x3adfac["y"] = _0x4351f8["getY"](_0x4130a3)),
            (_0x3adfac["z"] = _0x4351f8["getZ"](_0x4130a3)),
            _0x3adfac["applyMatrix4"](_0x3c3be3["matrixWorld"]),
            (_0x3e6f4b +=
              "v\x20" +
              _0x3adfac["x"] +
              "\x20" +
              _0x3adfac["y"] +
              "\x20" +
              _0x3adfac["z"] +
              "\x0a");
        }
      if (_0x1a8ecc === "Line") {
        _0x3e6f4b += "l\x20";
        for (
          let _0x20da54 = 0x1, _0x107843 = _0x4351f8["count"];
          _0x20da54 <= _0x107843;
          _0x20da54++
        ) {
          _0x3e6f4b += _0x29f90b + _0x20da54 + "\x20";
        }
        _0x3e6f4b += "\x0a";
      }
      if (_0x1a8ecc === "LineSegments")
        for (
          let _0x30896f = 0x1,
            _0x53aa0e = _0x30896f + 0x1,
            _0x4db1b4 = _0x4351f8["count"];
          _0x30896f < _0x4db1b4;
          _0x30896f += 0x2, _0x53aa0e = _0x30896f + 0x1
        ) {
          _0x3e6f4b +=
            "l\x20" +
            (_0x29f90b + _0x30896f) +
            "\x20" +
            (_0x29f90b + _0x53aa0e) +
            "\x0a";
        }
      _0x29f90b += _0x49a38c;
    }
    function _0x2fba0e(_0xc30951) {
      let _0x549615 = 0x0;
      const _0x51e065 = _0xc30951["geometry"];
      if (_0x51e065["isBufferGeometry"] !== !![])
        throw new Error(
          "THREE.OBJExporter:\x20Geometry\x20is\x20not\x20of\x20type\x20THREE.BufferGeometry."
        );
      const _0x2138af = _0x51e065["getAttribute"]("position"),
        _0x24d6de = _0x51e065["getAttribute"]("color");
      _0x3e6f4b += "o\x20" + _0xc30951["name"] + "\x0a";
      if (_0x2138af !== undefined)
        for (
          let _0x24d8c0 = 0x0, _0x15a3a0 = _0x2138af["count"];
          _0x24d8c0 < _0x15a3a0;
          _0x24d8c0++, _0x549615++
        ) {
          _0x3adfac["fromBufferAttribute"](_0x2138af, _0x24d8c0),
            _0x3adfac["applyMatrix4"](_0xc30951["matrixWorld"]),
            (_0x3e6f4b +=
              "v\x20" +
              _0x3adfac["x"] +
              "\x20" +
              _0x3adfac["y"] +
              "\x20" +
              _0x3adfac["z"]),
            _0x24d6de !== undefined &&
              (_0x2806a1["fromBufferAttribute"](_0x24d6de, _0x24d8c0),
              (_0x3e6f4b +=
                "\x20" +
                _0x2806a1["r"] +
                "\x20" +
                _0x2806a1["g"] +
                "\x20" +
                _0x2806a1["b"])),
            (_0x3e6f4b += "\x0a");
        }
      _0x3e6f4b += "p\x20";
      for (
        let _0x4cfc84 = 0x1, _0x5ac8db = _0x2138af["count"];
        _0x4cfc84 <= _0x5ac8db;
        _0x4cfc84++
      ) {
        _0x3e6f4b += _0x29f90b + _0x4cfc84 + "\x20";
      }
      (_0x3e6f4b += "\x0a"), (_0x29f90b += _0x549615);
    }
    _0x4f782b["traverse"](function (_0x5ecbb5) {
      _0x5ecbb5["isMesh"] === !![] && _0x373bdd(_0x5ecbb5),
        _0x5ecbb5["isLine"] === !![] && _0x75176c(_0x5ecbb5),
        _0x5ecbb5["isPoints"] === !![] && _0x2fba0e(_0x5ecbb5);
    });
    let _0x3c9e94 = "";
    for (let _0xfa1f69 in _0x573d45) {
      let _0x48ed74 = _0x573d45[_0xfa1f69];
      if (_0x48ed74["name"] !== "")
        _0x3c9e94 += "newmtl\x20" + _0x48ed74["name"] + "\x0a";
      else _0x3c9e94 += "newmtl\x20material" + _0x48ed74["id"] + "\x0a";
      (_0x3c9e94 += "Ns\x2010.0000\x0a"),
        (_0x3c9e94 += "Ni\x201.5000\x0a"),
        (_0x3c9e94 += "d\x201.0000\x0a"),
        (_0x3c9e94 += "Tr\x200.0000\x0a"),
        (_0x3c9e94 += "Tf\x201.0000\x201.0000\x201.0000\x0a"),
        (_0x3c9e94 += "illum\x202\x0a"),
        (_0x3c9e94 +=
          "Ka\x20" +
          _0x48ed74["color"]["r"] +
          "\x20" +
          _0x48ed74["color"]["g"] +
          "\x20" +
          _0x48ed74["color"]["b"] +
          "\x20" +
          "\x0a"),
        (_0x3c9e94 +=
          "Kd\x20" +
          _0x48ed74["color"]["r"] +
          "\x20" +
          _0x48ed74["color"]["g"] +
          "\x20" +
          _0x48ed74["color"]["b"] +
          "\x20" +
          "\x0a"),
        (_0x3c9e94 += "Ks\x200.0000\x200.0000\x200.0000\x0a"),
        (_0x3c9e94 += "Ke\x200.0000\x200.0000\x200.0000\x0a");
      if (_0x48ed74["map"] && _0x48ed74["map"] instanceof Texture) {
        var _0x4f47e6 = _0x48ed74["map"]["name"];
        (_0x3c9e94 += "map_Ka\x20" + _0x4f47e6 + "\x0a"),
          (_0x3c9e94 += "map_Kd\x20" + _0x4f47e6 + "\x0a");
      }
    }
    return { obj: _0x3e6f4b, mtl: _0x3c9e94 };
  }
}
class TypedArray {
  static ["Int8Array"] = Int8Array;
  static ["Uint8Array"] = Uint8Array;
  static ["Uint8ClampedArray"] = Uint8ClampedArray;
  static ["Int16Array"] = Int16Array;
  static ["Uint16Array"] = Uint16Array;
  static ["Int32Array"] = Int32Array;
  static ["Uint32Array"] = Uint32Array;
  static ["Float32Array"] = Float32Array;
  static ["Float64Array"] = Float64Array;
  static ["BigInt64Array"] = BigInt64Array;
  static ["BigUint64Array"] = BigUint64Array;
  static ["isTypedArray"](_0x47b1c8) {
    return (
      _0x47b1c8 instanceof TypedArray["Int8Array"] ||
      _0x47b1c8 instanceof TypedArray["Uint8Array"] ||
      _0x47b1c8 instanceof TypedArray["Uint8ClampedArray"] ||
      _0x47b1c8 instanceof TypedArray["Int16Array"] ||
      _0x47b1c8 instanceof TypedArray["Uint16Array"] ||
      _0x47b1c8 instanceof TypedArray["Int32Array"] ||
      _0x47b1c8 instanceof TypedArray["Uint32Array"] ||
      _0x47b1c8 instanceof TypedArray["Float32Array"] ||
      _0x47b1c8 instanceof TypedArray["Float64Array"] ||
      _0x47b1c8 instanceof TypedArray["BigInt64Array"] ||
      _0x47b1c8 instanceof TypedArray["BigUint64Array"]
    );
  }
}
class BufferAttributeSerializer {
  static ["toWorkerData"](_0x598061) {
    if (!TypedArray["isTypedArray"](_0x598061["array"]))
      throw "BufferAttributeSerializer.toWorkerData:\x20only\x20typed\x20arrays\x20are\x20supported";
    const _0x2511dc = {
      metadata: {
        type: "BufferAttributeWorkerData",
        generator: "BufferAttributeSerializer.toWorkerData"
      },
      data: {
        type: _0x598061["array"]["constructor"]["name"],
        buffer: _0x598061["array"]["buffer"],
        itemSize: _0x598061["itemSize"],
        normalized: _0x598061["normalized"],
        name: _0x598061["name"]
      }
    };
    return _0x2511dc;
  }
  static ["fromWorkerData"](_0x117c2d) {
    if (_0x117c2d["metadata"]["type"] != "BufferAttributeWorkerData")
      throw "BufferAttributeSerializer:\x20data\x20is\x20not\x20of\x20type\x20BufferAttribute";
    const _0x274766 = new BufferAttribute(
      new TypedArray[_0x117c2d["data"]["type"]](_0x117c2d["data"]["buffer"]),
      _0x117c2d["data"]["itemSize"],
      _0x117c2d["data"]["normalized"]
    );
    return (_0x274766["name"] = _0x117c2d["data"]["name"]), _0x274766;
  }
  static ["getTransferable"](_0x69e374) {
    if (_0x69e374["metadata"]["type"] != "BufferAttributeWorkerData")
      throw "BufferAttributeSerializer:\x20data\x20is\x20not\x20of\x20type\x20BufferAttribute";
    return _0x69e374["data"]["buffer"];
  }
}
class BufferGeometrySerializer {
  static ["toWorkerData"](_0x53b8cd) {
    const _0x4688c1 = _0x53b8cd["index"]
        ? BufferAttributeSerializer["toWorkerData"](_0x53b8cd["index"])
        : undefined,
      _0x47dcff = {};
    Object["keys"](_0x53b8cd["attributes"])["forEach"]((_0x5416bf) => {
      const _0x206b5e = _0x53b8cd["attributes"][_0x5416bf];
      if (!(_0x206b5e instanceof BufferAttribute))
        throw "BufferGeometrySerializer.toWorkerData:\x20only\x20BufferAttribute\x20are\x20supported";
      _0x47dcff[_0x5416bf] =
        BufferAttributeSerializer["toWorkerData"](_0x206b5e);
    });
    const _0x1cf4b5 = {};
    Object["keys"](_0x53b8cd["morphAttributes"])["forEach"]((_0x19f4bb) => {
      const _0x484fb7 = _0x53b8cd["morphAttributes"][_0x19f4bb];
      _0x1cf4b5[_0x19f4bb] = [];
      for (let _0x1dfef1 = 0x0; _0x1dfef1 < _0x484fb7["length"]; _0x1dfef1++) {
        const _0x3214cd = _0x484fb7[_0x1dfef1];
        if (!(_0x3214cd instanceof BufferAttribute))
          throw "BufferGeometrySerializer.toWorkerData:\x20only\x20BufferAttribute\x20are\x20supported";
        _0x1cf4b5[_0x19f4bb]["push"](
          BufferAttributeSerializer["toWorkerData"](_0x3214cd)
        );
      }
    });
    const _0x4b917c = _0x53b8cd["groups"]
        ? JSON["parse"](JSON["stringify"](_0x53b8cd["groups"]))
        : undefined,
      _0x4b7633 = _0x53b8cd["boundingSphere"]
        ? {
            center: _0x53b8cd["boundingSphere"]["center"]["toArray"](),
            radius: _0x53b8cd["boundingSphere"]["radius"]
          }
        : undefined,
      _0x5b2183 = _0x53b8cd["userData"] ?? undefined,
      _0x1eef2b = {
        metadata: {
          type: "BufferGeometryWorkerData",
          generator: "BufferGeometrySerializer.toWorkerData"
        },
        data: {
          name: _0x53b8cd["name"],
          index: _0x4688c1,
          attributes: _0x47dcff,
          morphAttributes: _0x1cf4b5,
          groups: _0x4b917c,
          boundingSphere: _0x4b7633,
          userData: _0x5b2183
        }
      };
    return _0x1eef2b;
  }
  static ["fromWorkerData"](_0x250655) {
    if (_0x250655["metadata"]["type"] != "BufferGeometryWorkerData")
      throw "BufferGeometrySerializer:\x20data\x20is\x20not\x20of\x20type\x20BufferGeometry";
    const {
        name: _0x5c9da2,
        index: _0x39670e,
        attributes: _0x5b0602,
        morphAttributes: _0x53ff42,
        groups: _0x14280e,
        boundingSphere: _0x3d308f,
        userData: _0x4d58ba
      } = _0x250655["data"],
      _0x51758d = new BufferGeometry();
    for (let _0x4c27f5 in _0x5b0602) {
      const _0xf4e8c6 = _0x5b0602[_0x4c27f5];
      _0x51758d["setAttribute"](
        _0x4c27f5,
        BufferAttributeSerializer["fromWorkerData"](_0xf4e8c6)
      );
    }
    for (let _0x539f5f in _0x53ff42) {
      const _0x5214f6 = _0x53ff42[_0x539f5f];
      _0x51758d["morphAttributes"][_0x539f5f] = [];
      for (let _0x57b18a = 0x0; _0x57b18a < _0x5214f6["length"]; ++_0x57b18a) {
        _0x51758d["morphAttributes"][_0x539f5f]["push"](
          BufferAttributeSerializer["fromWorkerData"](_0x5214f6[_0x57b18a])
        );
      }
    }
    return (
      _0x39670e &&
        _0x51758d["setIndex"](
          BufferAttributeSerializer["fromWorkerData"](_0x39670e)
        ),
      _0x14280e &&
        _0x14280e["forEach"]((_0x1f9e65) => {
          _0x51758d["addGroup"](
            _0x1f9e65["start"],
            _0x1f9e65["count"],
            _0x1f9e65["materialIndex"]
          );
        }),
      _0x3d308f &&
        (_0x51758d["boundingSphere"] = new Sphere(
          _0x3d308f["center"]
            ? new Vector3()["fromArray"](_0x3d308f["center"])
            : new Vector3(),
          _0x3d308f["radius"]
        )),
      _0x4d58ba && (_0x51758d["userData"] = _0x4d58ba),
      (_0x51758d["name"] = _0x5c9da2),
      _0x51758d
    );
  }
  static ["getTransferables"](_0x3d9889) {
    if (_0x3d9889["metadata"]["type"] != "BufferGeometryWorkerData")
      throw "BufferGeometrySerializer:\x20data\x20is\x20not\x20of\x20type\x20BufferGeometry";
    const _0x28b19a = Object["keys"](_0x3d9889["data"]["attributes"])["map"](
        (_0x3438e5) =>
          BufferAttributeSerializer["getTransferable"](
            _0x3d9889["data"]["attributes"][_0x3438e5]
          )
      ),
      _0x2180bd = [];
    for (const _0xcc86ad of Object["keys"](
      _0x3d9889["data"]["morphAttributes"]
    ))
      for (
        let _0x1da2fc = 0x0;
        _0x1da2fc < _0x3d9889["data"]["morphAttributes"][_0xcc86ad]["length"];
        ++_0x1da2fc
      )
        _0x2180bd["push"](
          BufferAttributeSerializer["getTransferable"](
            _0x3d9889["data"]["morphAttributes"][_0xcc86ad][_0x1da2fc]
          )
        );
    return _0x3d9889["data"]["index"]
      ? [
          BufferAttributeSerializer["getTransferable"](
            _0x3d9889["data"]["index"]
          ),
          ..._0x28b19a
        ]
      : _0x28b19a;
  }
}
class BufferGeometryComputations {
  static ["computeVertexBarycentricCoordinates"](_0x27bf1e) {
    if (_0x27bf1e["getIndex"]() !== null)
      throw "Error\x20:\x20cannot\x20add\x20barycentric\x20coordinates\x20on\x20indexed\x20geometry.\x20Please\x20call\x20toNonIndexed\x20first.";
    const _0xbf7e95 = _0x27bf1e["getAttribute"]("position")?.["count"];
    let _0x2a2eb8 = _0x27bf1e["getAttribute"]("barycentric");
    _0x2a2eb8 === undefined &&
      _0x27bf1e["setAttribute"](
        "barycentric",
        new BufferAttribute(new Float32Array(_0xbf7e95 * 0x3), 0x3)
      );
    _0x2a2eb8 = _0x27bf1e["getAttribute"]("barycentric");
    if (!(_0x2a2eb8 instanceof BufferAttribute))
      throw "Error:\x20cannot\x20compute\x20barycentric\x20coordinates\x20as\x20the\x20barycentric\x20attribute\x20is\x20not\x20a\x20BufferAttribute.\x20Other\x20types\x20are\x20not\x20supported\x20(yet).";
    const _0x3ff10a = _0x2a2eb8["count"];
    for (let _0x323bb8 = 0x0; _0x323bb8 < _0x3ff10a; _0x323bb8 += 0x3) {
      _0x2a2eb8["setXYZ"](_0x323bb8, 0x1, 0x0, 0x0),
        _0x2a2eb8["setXYZ"](_0x323bb8 + 0x1, 0x0, 0x1, 0x0),
        _0x2a2eb8["setXYZ"](_0x323bb8 + 0x2, 0x0, 0x0, 0x1);
    }
    return _0x27bf1e;
  }
  static ["splitIntoConnectedParts"](_0x515e05) {
    const _0xa517c3 = _0x515e05["getIndex"]();
    if (_0xa517c3 === null)
      throw "BufferGeometryUtils.splitIntoConnectedParts:\x20can\x27t\x20split\x20a\x20non-indexed\x20geometry.\x20Please\x20merge\x20your\x20geometry\x20first";
    const _0x58d85d = _0x515e05["getAttribute"]("position"),
      _0x10b8cf = _0xa517c3["array"],
      _0x5531b5 = _0x58d85d["count"],
      _0xb4ef34 = _0x10b8cf["length"] / 0x3,
      _0x2db727 = [];
    let _0x348498 = 0x0;
    function _0x21ba9c() {
      return { id: _0x348498++, vertices: [] };
    }
    function _0x1998f2(_0xa9038c, _0x94dedd, _0x30bc2f) {
      if (_0xa9038c["id"] == _0x94dedd["id"]) return _0xa9038c;
      if (_0xa9038c["vertices"]["length"] == 0x0) return _0x94dedd;
      if (_0x94dedd["vertices"]["length"] == 0x0) return _0xa9038c;
      const _0x50d5d8 =
          _0xa9038c["vertices"]["length"] > _0x94dedd["vertices"]["length"]
            ? _0xa9038c
            : _0x94dedd,
        _0x3f5a64 =
          _0xa9038c["vertices"]["length"] > _0x94dedd["vertices"]["length"]
            ? _0x94dedd
            : _0xa9038c;
      for (let _0xa1113b of _0x3f5a64["vertices"]) {
        _0x50d5d8["vertices"]["push"](_0xa1113b),
          (_0x30bc2f[_0xa1113b] = _0x50d5d8);
      }
      return _0x50d5d8;
    }
    for (let _0x40e253 = 0x0; _0x40e253 < _0xb4ef34; ++_0x40e253) {
      const _0x75903a = _0x10b8cf[0x3 * _0x40e253],
        _0x3051c5 = _0x10b8cf[0x3 * _0x40e253 + 0x1],
        _0x491c67 = _0x10b8cf[0x3 * _0x40e253 + 0x2],
        _0x49726d = [];
      _0x2db727[_0x75903a] && _0x49726d["push"](_0x2db727[_0x75903a]);
      _0x2db727[_0x3051c5] && _0x49726d["push"](_0x2db727[_0x3051c5]);
      _0x2db727[_0x491c67] && _0x49726d["push"](_0x2db727[_0x491c67]);
      let _0x2d9679 = _0x21ba9c();
      _0x49726d["forEach"](
        (_0x313d6f) => (_0x2d9679 = _0x1998f2(_0x2d9679, _0x313d6f, _0x2db727))
      ),
        !_0x2db727[_0x75903a] && _0x2d9679["vertices"]["push"](_0x75903a),
        !_0x2db727[_0x3051c5] && _0x2d9679["vertices"]["push"](_0x3051c5),
        !_0x2db727[_0x491c67] && _0x2d9679["vertices"]["push"](_0x491c67),
        (_0x2db727[_0x75903a] = _0x2d9679),
        (_0x2db727[_0x3051c5] = _0x2d9679),
        (_0x2db727[_0x491c67] = _0x2d9679);
    }
    for (let _0x4e2765 = 0x0; _0x4e2765 < _0x5531b5; ++_0x4e2765) {
      !_0x2db727[_0x4e2765] &&
        (_0x2db727[_0x4e2765] = { id: _0x348498++, vertices: [_0x4e2765] });
    }
    function _0x229885(_0x8daabd, _0x3873e6) {
      for (const _0x71e753 in _0x515e05["attributes"]) {
        let _0x5e4385 = _0x515e05["getAttribute"](_0x71e753);
        for (
          let _0x172a52 = 0x0;
          _0x172a52 < _0x5e4385["itemSize"];
          ++_0x172a52
        ) {
          switch (_0x172a52) {
            case 0x0: {
              _0x8daabd["attributes"][_0x71e753]["push"](
                _0x3873e6["attributes"][_0x71e753]["x"]
              );
              break;
            }
            case 0x1: {
              _0x8daabd["attributes"][_0x71e753]["push"](
                _0x3873e6["attributes"][_0x71e753]["y"]
              );
              break;
            }
            case 0x2: {
              _0x8daabd["attributes"][_0x71e753]["push"](
                _0x3873e6["attributes"][_0x71e753]["z"]
              );
              break;
            }
            case 0x3: {
              _0x8daabd["attributes"][_0x71e753]["push"](
                _0x3873e6["attributes"][_0x71e753]["w"]
              );
              break;
            }
          }
        }
      }
      for (const _0x4dd3ba in _0x515e05["morphAttributes"]) {
        let _0x3dc7ac = _0x515e05["morphAttributes"][_0x4dd3ba];
        for (
          let _0x26bc39 = 0x0;
          _0x26bc39 < _0x3dc7ac["length"];
          ++_0x26bc39
        ) {
          for (
            let _0xee01d2 = 0x0;
            _0xee01d2 < _0x3dc7ac[_0x26bc39]["itemSize"];
            ++_0xee01d2
          ) {
            switch (_0xee01d2) {
              case 0x0: {
                _0x8daabd["morphAttributes"][_0x4dd3ba][_0x26bc39]["push"](
                  _0x3873e6["morphAttributes"][_0x4dd3ba][_0x26bc39]["x"]
                );
                break;
              }
              case 0x1: {
                _0x8daabd["morphAttributes"][_0x4dd3ba][_0x26bc39]["push"](
                  _0x3873e6["morphAttributes"][_0x4dd3ba][_0x26bc39]["y"]
                );
                break;
              }
              case 0x2: {
                _0x8daabd["morphAttributes"][_0x4dd3ba][_0x26bc39]["push"](
                  _0x3873e6["morphAttributes"][_0x4dd3ba][_0x26bc39]["z"]
                );
                break;
              }
              case 0x3: {
                _0x8daabd["morphAttributes"][_0x4dd3ba][_0x26bc39]["push"](
                  _0x3873e6["morphAttributes"][_0x4dd3ba][_0x26bc39]["w"]
                );
                break;
              }
            }
          }
        }
      }
    }
    function _0x1c309e(_0x5c09e2, _0x1f1d0d, _0x263bbc, _0x40b365) {
      _0x5c09e2["attributes"]["index"]["push"](_0x1f1d0d),
        _0x5c09e2["attributes"]["index"]["push"](_0x263bbc),
        _0x5c09e2["attributes"]["index"]["push"](_0x40b365);
    }
    const _0x2ba689 = {},
      _0x53c1b6 = [];
    for (let _0x2a89f1 = 0x0; _0x2a89f1 < _0x5531b5; ++_0x2a89f1) {
      let _0x5b37ea = _0x2db727[_0x2a89f1];
      if (!_0x2ba689[_0x5b37ea["id"]]) {
        _0x2ba689[_0x5b37ea["id"]] = { attributes: {}, morphAttributes: {} };
        for (const _0x1de264 in _0x515e05["attributes"]) {
          _0x2ba689[_0x5b37ea["id"]]["attributes"][_0x1de264] = [];
        }
        _0x2ba689[_0x5b37ea["id"]]["attributes"]["index"] = [];
        for (const _0x232763 in _0x515e05["morphAttributes"]) {
          _0x2ba689[_0x5b37ea["id"]]["morphAttributes"][_0x232763] = new Array(
            _0x515e05["morphAttributes"][_0x232763]["length"]
          );
          for (
            let _0x572f10 = 0x0;
            _0x572f10 <
            _0x2ba689[_0x5b37ea["id"]]["morphAttributes"][_0x232763]["length"];
            ++_0x572f10
          )
            _0x2ba689[_0x5b37ea["id"]]["morphAttributes"][_0x232763][
              _0x572f10
            ] = [];
        }
      }
      const _0x30d0e9 = { attributes: {}, morphAttributes: {} };
      for (const _0x5ec9ed in _0x515e05["attributes"]) {
        let _0x435289 = _0x515e05["getAttribute"](_0x5ec9ed);
        switch (_0x435289["itemSize"]) {
          case 0x1: {
            _0x30d0e9["attributes"][_0x5ec9ed] = _0x435289["getX"](_0x2a89f1);
            break;
          }
          case 0x2: {
            _0x30d0e9["attributes"][_0x5ec9ed] = new Vector2(
              _0x435289["getX"](_0x2a89f1),
              _0x435289["getY"](_0x2a89f1)
            );
            break;
          }
          case 0x3: {
            _0x30d0e9["attributes"][_0x5ec9ed] = new Vector3(
              _0x435289["getX"](_0x2a89f1),
              _0x435289["getY"](_0x2a89f1),
              _0x435289["getZ"](_0x2a89f1)
            );
            break;
          }
          case 0x4: {
            _0x30d0e9["attributes"][_0x5ec9ed] = new Vector4(
              _0x435289["getX"](_0x2a89f1),
              _0x435289["getY"](_0x2a89f1),
              _0x435289["getZ"](_0x2a89f1),
              _0x435289["getW"](_0x2a89f1)
            );
            break;
          }
          default: {
            _0x30d0e9["attributes"][_0x5ec9ed] = _0x435289["getX"](_0x2a89f1);
          }
        }
      }
      for (const _0x3e7c11 in _0x515e05["morphAttributes"]) {
        let _0x103e5c = _0x515e05["morphAttributes"][_0x3e7c11];
        _0x30d0e9["morphAttributes"][_0x3e7c11] = new Array(
          _0x103e5c["length"]
        );
        for (
          let _0x5da83f = 0x0;
          _0x5da83f < _0x103e5c["length"];
          ++_0x5da83f
        ) {
          switch (_0x103e5c[_0x5da83f]["itemSize"]) {
            case 0x1: {
              _0x30d0e9["morphAttributes"][_0x3e7c11][_0x5da83f] =
                _0x103e5c[_0x5da83f]["getX"](_0x2a89f1);
              break;
            }
            case 0x2: {
              _0x30d0e9["morphAttributes"][_0x3e7c11][_0x5da83f] = new Vector2(
                _0x103e5c[_0x5da83f]["getX"](_0x2a89f1),
                _0x103e5c[_0x5da83f]["getY"](_0x2a89f1)
              );
              break;
            }
            case 0x3: {
              _0x30d0e9["morphAttributes"][_0x3e7c11][_0x5da83f] = new Vector3(
                _0x103e5c[_0x5da83f]["getX"](_0x2a89f1),
                _0x103e5c[_0x5da83f]["getY"](_0x2a89f1),
                _0x103e5c[_0x5da83f]["getZ"](_0x2a89f1)
              );
              break;
            }
            case 0x4: {
              _0x30d0e9["morphAttributes"][_0x3e7c11][_0x5da83f] = new Vector4(
                _0x103e5c[_0x5da83f]["getX"](_0x2a89f1),
                _0x103e5c[_0x5da83f]["getY"](_0x2a89f1),
                _0x103e5c[_0x5da83f]["getZ"](_0x2a89f1),
                _0x103e5c[_0x5da83f]["getW"](_0x2a89f1)
              );
              break;
            }
            default: {
              _0x30d0e9["morphAttributes"][_0x3e7c11][_0x5da83f] =
                _0x103e5c[_0x5da83f]["getX"](_0x2a89f1);
            }
          }
        }
      }
      (_0x30d0e9["attributes"]["index"] = _0xa517c3["getX"](_0x2a89f1)),
        _0x229885(_0x2ba689[_0x5b37ea["id"]], _0x30d0e9),
        (_0x53c1b6[_0x2a89f1] =
          _0x2ba689[_0x5b37ea["id"]]["attributes"]["position"]["length"] / 0x3 -
          0x1);
    }
    for (let _0x3594b4 = 0x0; _0x3594b4 < _0xb4ef34; ++_0x3594b4) {
      let _0x49b107 = _0x10b8cf[0x3 * _0x3594b4],
        _0x3d8a47 = _0x10b8cf[0x3 * _0x3594b4 + 0x1],
        _0x37e754 = _0x10b8cf[0x3 * _0x3594b4 + 0x2];
      _0x1c309e(
        _0x2ba689[_0x2db727[_0x49b107]["id"]],
        _0x53c1b6[_0x49b107],
        _0x53c1b6[_0x3d8a47],
        _0x53c1b6[_0x37e754]
      );
    }
    const _0x182450 = [];
    for (let _0x4ee60c of Object["keys"](_0x2ba689)) {
      const _0x58f427 = _0x2ba689[_0x4ee60c],
        _0x460b10 = new BufferGeometry();
      _0x460b10["setIndex"](
        new BufferAttribute(
          new Uint32Array(_0x58f427["attributes"]["index"]),
          0x1
        )
      );
      for (const _0x4e376a in _0x515e05["attributes"]) {
        let _0x2f2fa3 = _0x515e05["getAttribute"](_0x4e376a);
        _0x460b10["setAttribute"](
          _0x4e376a,
          new BufferAttribute(
            new Float32Array(_0x58f427["attributes"][_0x4e376a]),
            _0x2f2fa3["itemSize"]
          )
        );
      }
      for (const _0x1e06df in _0x515e05["morphAttributes"]) {
        let _0x255063 = _0x515e05["morphAttributes"][_0x1e06df];
        _0x460b10["morphAttributes"][_0x1e06df] = [];
        for (let _0x4d9c06 = 0x0; _0x4d9c06 < _0x255063["length"]; ++_0x4d9c06)
          _0x460b10["morphAttributes"][_0x1e06df]["push"](
            new BufferAttribute(
              new Float32Array(
                _0x58f427["morphAttributes"][_0x1e06df][_0x4d9c06]
              ),
              _0x255063[_0x4d9c06]["itemSize"]
            )
          );
      }
      _0x182450["push"](_0x460b10);
    }
    return _0x182450;
  }
  static ["computeSurface"](_0x1fec5a) {
    let _0x49f480 = 0x0,
      _0x53d562 = new Vector3(),
      _0xd4e36c = new Vector3(),
      _0x5b97ea = new Vector3(),
      _0x464184 = new Triangle(),
      _0x1409aa = _0x1fec5a["getAttribute"]("position"),
      _0x4a5690 = 0x0;
    if (_0x1fec5a["getIndex"]() === null)
      for (
        let _0x38f6ef = 0x0;
        _0x38f6ef < _0x1409aa["count"];
        _0x38f6ef += 0x3
      ) {
        _0x53d562["set"](
          _0x1409aa["getX"](_0x38f6ef),
          _0x1409aa["getY"](_0x38f6ef),
          _0x1409aa["getZ"](_0x38f6ef)
        ),
          _0xd4e36c["set"](
            _0x1409aa["getX"](_0x38f6ef + 0x1),
            _0x1409aa["getY"](_0x38f6ef + 0x1),
            _0x1409aa["getZ"](_0x38f6ef + 0x1)
          ),
          _0x5b97ea["set"](
            _0x1409aa["getX"](_0x38f6ef + 0x2),
            _0x1409aa["getY"](_0x38f6ef + 0x2),
            _0x1409aa["getZ"](_0x38f6ef + 0x2)
          ),
          _0x464184["set"](_0x53d562, _0xd4e36c, _0x5b97ea),
          (_0x4a5690 = _0x464184["getArea"]()),
          (_0x49f480 += !isNaN(_0x4a5690) ? _0x4a5690 : 0x0);
      }
    else {
      const _0x4f72eb = _0x1fec5a["index"];
      let _0x5ef26c = 0x0,
        _0x32946b = 0x0,
        _0x21030d = 0x0;
      for (
        let _0x5f0139 = 0x0;
        _0x5f0139 < _0x4f72eb["count"];
        _0x5f0139 += 0x3
      ) {
        (_0x5ef26c = _0x4f72eb["getX"](_0x5f0139)),
          (_0x32946b = _0x4f72eb["getX"](_0x5f0139 + 0x1)),
          (_0x21030d = _0x4f72eb["getX"](_0x5f0139 + 0x2)),
          _0x53d562["set"](
            _0x1409aa["getX"](_0x5ef26c),
            _0x1409aa["getY"](_0x5ef26c),
            _0x1409aa["getZ"](_0x5ef26c)
          ),
          _0xd4e36c["set"](
            _0x1409aa["getX"](_0x32946b),
            _0x1409aa["getY"](_0x32946b),
            _0x1409aa["getZ"](_0x32946b)
          ),
          _0x5b97ea["set"](
            _0x1409aa["getX"](_0x21030d),
            _0x1409aa["getY"](_0x21030d),
            _0x1409aa["getZ"](_0x21030d)
          ),
          _0x464184["set"](_0x53d562, _0xd4e36c, _0x5b97ea),
          (_0x4a5690 = _0x464184["getArea"]()),
          (_0x49f480 += !isNaN(_0x4a5690) ? _0x4a5690 : 0x0);
      }
    }
    return _0x49f480;
  }
  static ["computeVolume"](_0x2ded13) {
    let _0x22c070 = 0x0,
      _0x3c6237 = new Matrix3(),
      _0x14296 = _0x2ded13["getAttribute"]("position");
    if (_0x2ded13["getIndex"]() === null)
      for (
        let _0x563068 = 0x0;
        _0x563068 < _0x14296["count"];
        _0x563068 += 0x3
      ) {
        _0x3c6237["set"](
          _0x14296["getX"](_0x563068),
          _0x14296["getY"](_0x563068),
          _0x14296["getZ"](_0x563068),
          _0x14296["getX"](_0x563068 + 0x1),
          _0x14296["getY"](_0x563068 + 0x1),
          _0x14296["getZ"](_0x563068 + 0x1),
          _0x14296["getX"](_0x563068 + 0x2),
          _0x14296["getY"](_0x563068 + 0x2),
          _0x14296["getZ"](_0x563068 + 0x2)
        ),
          (_0x22c070 += _0x3c6237["determinant"]());
      }
    else {
      const _0xa9131e = _0x2ded13["index"];
      let _0x45bdd9 = 0x0,
        _0x48b919 = 0x0,
        _0x2049e1 = 0x0;
      for (
        let _0x56995e = 0x0;
        _0x56995e < _0xa9131e["count"];
        _0x56995e += 0x3
      ) {
        (_0x45bdd9 = _0xa9131e["getX"](_0x56995e)),
          (_0x48b919 = _0xa9131e["getX"](_0x56995e + 0x1)),
          (_0x2049e1 = _0xa9131e["getX"](_0x56995e + 0x2)),
          _0x3c6237["set"](
            _0x14296["getX"](_0x45bdd9),
            _0x14296["getY"](_0x45bdd9),
            _0x14296["getZ"](_0x45bdd9),
            _0x14296["getX"](_0x48b919),
            _0x14296["getY"](_0x48b919),
            _0x14296["getZ"](_0x48b919),
            _0x14296["getX"](_0x2049e1),
            _0x14296["getY"](_0x2049e1),
            _0x14296["getZ"](_0x2049e1)
          ),
          (_0x22c070 += _0x3c6237["determinant"]());
      }
    }
    return _0x22c070 / 0x6;
  }
  static ["computeEdgeLengthData"](_0x4f5360) {
    let _0x5e0eb0 = [new Vector3(), new Vector3(), new Vector3()],
      _0x8ec9e7 = [new Vector3(), new Vector3(), new Vector3(), new Vector3()];
    _0x8ec9e7[0x3] = _0x8ec9e7[0x0];
    let _0x1474dd = null;
    _0x4f5360["getIndex"]() !== null &&
      (_0x1474dd = _0x4f5360["getIndex"]()?.["array"] || null);
    let _0x11dc33 = _0x4f5360["getAttribute"]("position"),
      _0x4200d1 = _0x11dc33["count"],
      _0x2bf6df =
        _0x1474dd !== null ? _0x1474dd["length"] / 0x3 : _0x4200d1 / 0x3,
      _0xad64c0 = { average: 0x0, min: Number["MAX_VALUE"], max: 0x0 },
      _0x266d79 = 0x0,
      _0x225583 = [0x0, 0x0, 0x0];
    for (let _0x18e6ea = 0x0; _0x18e6ea < _0x2bf6df; ++_0x18e6ea) {
      (_0x225583[0x0] =
        _0x1474dd !== null ? _0x1474dd[0x3 * _0x18e6ea] : 0x3 * _0x18e6ea),
        (_0x225583[0x1] =
          _0x1474dd !== null
            ? _0x1474dd[0x3 * _0x18e6ea + 0x1]
            : 0x3 * _0x18e6ea + 0x1),
        (_0x225583[0x2] =
          _0x1474dd !== null
            ? _0x1474dd[0x3 * _0x18e6ea + 0x2]
            : 0x3 * _0x18e6ea + 0x2);
      for (let _0x2317fe = 0x0; _0x2317fe < 0x3; ++_0x2317fe) {
        _0x8ec9e7[_0x2317fe]["set"](
          _0x11dc33["getX"](_0x225583[_0x2317fe]),
          _0x11dc33["getY"](_0x225583[_0x2317fe]),
          _0x11dc33["getZ"](_0x225583[_0x2317fe])
        );
      }
      for (let _0x38c94d = 0x0; _0x38c94d < 0x3; ++_0x38c94d) {
        _0x5e0eb0[_0x38c94d]["subVectors"](
          _0x8ec9e7[_0x38c94d],
          _0x8ec9e7[_0x38c94d + 0x1]
        );
        let _0x8753be = _0x5e0eb0[_0x38c94d]["length"]();
        (_0xad64c0["average"] += _0x8753be),
          (_0xad64c0["min"] = Math["min"](_0x8753be, _0xad64c0["min"])),
          (_0xad64c0["max"] = Math["max"](_0x8753be, _0xad64c0["max"]));
      }
      _0x266d79 += 0x3;
    }
    return (_0xad64c0["average"] = _0xad64c0["average"] / _0x266d79), _0xad64c0;
  }
}
class FaceHelper {
  ["g"];
  ["indices"];
  ["position"];
  ["box"] = new Box3()["makeEmpty"]();
  ["vA"] = new Vector3();
  ["vB"] = new Vector3();
  ["vC"] = new Vector3();
  constructor(_0x5d84ed) {
    this["g"] = _0x5d84ed;
    const _0x5c5e8d = _0x5d84ed["getIndex"]();
    (this["indices"] = _0x5c5e8d ? _0x5c5e8d["array"] : undefined),
      (this["position"] = _0x5d84ed["getAttribute"]("position")["array"]);
  }
  ["computeFaceHelper"](_0x1d5043) {
    if (this["indices"]) {
      var _0x13d7b2 = 0x3 * _0x1d5043;
      this["vA"]["fromArray"](
        this["position"],
        this["indices"][_0x13d7b2] * 0x3
      ),
        this["vB"]["fromArray"](
          this["position"],
          this["indices"][_0x13d7b2 + 0x1] * 0x3
        ),
        this["vC"]["fromArray"](
          this["position"],
          this["indices"][_0x13d7b2 + 0x2] * 0x3
        );
    } else {
      var _0x13d7b2 = 0x9 * _0x1d5043;
      this["vA"]["fromArray"](this["position"], 0x9 * _0x1d5043),
        this["vB"]["fromArray"](this["position"], 0x9 * _0x1d5043 + 0x3),
        this["vC"]["fromArray"](this["position"], 0x9 * _0x1d5043 + 0x6);
    }
    this["box"]["makeEmpty"](),
      this["box"]["expandByPoint"](this["vA"]),
      this["box"]["expandByPoint"](this["vB"]),
      this["box"]["expandByPoint"](this["vC"]);
  }
}
class OctreeLight extends Box3 {
  ["children"];
  ["data"];
  ["max_level"] = 0x0;
  get ["maxLevel"]() {
    return this["max_level"];
  }
  constructor(_0x4ce754, _0x2590ee, _0x306988) {
    super(_0x4ce754, _0x2590ee), (this["max_level"] = _0x306988 || 0x0);
  }
  ["copy"](_0x3bab40) {
    super["copy"](_0x3bab40);
    _0x3bab40 instanceof OctreeLight &&
      _0x3bab40["children"] &&
      (this["children"] = [
        _0x3bab40["children"][0x0]["clone"](),
        _0x3bab40["children"][0x1]["clone"](),
        _0x3bab40["children"][0x2]["clone"](),
        _0x3bab40["children"][0x3]["clone"](),
        _0x3bab40["children"][0x4]["clone"](),
        _0x3bab40["children"][0x5]["clone"](),
        _0x3bab40["children"][0x6]["clone"](),
        _0x3bab40["children"][0x7]["clone"]()
      ]);
    if (_0x3bab40 instanceof OctreeLight && _0x3bab40["data"]) {
      this["data"] = new Array(_0x3bab40["data"]["length"]);
      for (
        var _0x2ec5e9 = 0x0;
        _0x2ec5e9 < this["data"]["length"];
        ++_0x2ec5e9
      ) {
        this["data"][_0x2ec5e9] = _0x3bab40["data"][_0x2ec5e9];
      }
    }
    return (
      _0x3bab40 instanceof OctreeLight &&
        _0x3bab40["max_level"] &&
        (this["max_level"] = _0x3bab40["max_level"]),
      this
    );
  }
  ["subdivide"] = (function () {
    var half_size = new Vector3();
    return function () {
      if (this["children"])
        throw "Cannot\x20subdivide\x20this\x20octree\x20cell,\x20it\x20is\x20already\x20subdivided.";
      const children = [];
      this["getSize"](half_size), half_size["multiplyScalar"](0.5);
      for (let i = 0x0; i < 0x2; ++i) {
        for (let j = 0x0; j < 0x2; ++j) {
          for (let k = 0x0; k < 0x2; ++k) {
            let new_min = new Vector3(
              this["min"]["x"] + i * half_size["x"],
              this["min"]["y"] + j * half_size["y"],
              this["min"]["z"] + k * half_size["z"]
            );
            children["push"](
              new OctreeLight(
                new_min,
                new_min["clone"]()["add"](half_size),
                this["max_level"] - 0x1
              )
            );
          }
        }
      }
      return (this["children"] = children), this["children"];
    };
  })();
  ["buildFromBufferGeometry"](_0x212d93, _0xf1de90, _0x4566a) {
    this["max_level"] = _0xf1de90;
    !_0x212d93["boundingBox"] && _0x212d93["computeBoundingBox"]();
    _0x212d93["boundingBox"] && this["copy"](_0x212d93["boundingBox"]);
    var _0x1e4292 = new FaceHelper(_0x212d93);
    const _0x36e4a4 = _0x212d93["index"]
      ? _0x212d93["index"]["count"] / 0x3
      : _0x212d93["attributes"]["position"]["count"] / 0x3;
    for (var _0xaf8c98 = 0x0; _0xaf8c98 < _0x36e4a4; _0xaf8c98++) {
      _0x1e4292["computeFaceHelper"](_0xaf8c98),
        this["insertFace"](_0xaf8c98, _0x1e4292, _0xf1de90, _0x4566a);
    }
  }
  ["insertFace"](_0x4b95a0, _0x52a133, _0x270f16, _0x27b1e9) {
    if (this["intersectsBox"](_0x52a133["box"])) {
      if (_0x270f16 === 0x0)
        (this["data"] = this["data"] || []), this["data"]["push"](_0x4b95a0);
      else {
        if (this["children"])
          for (var _0x4974b1 = 0x0; _0x4974b1 < 0x8; ++_0x4974b1) {
            this["children"][_0x4974b1]["insertFace"](
              _0x4b95a0,
              _0x52a133,
              _0x270f16 - 0x1,
              _0x27b1e9
            );
          }
        else {
          if (this["data"] === undefined || this["data"]["length"] < _0x27b1e9)
            (this["data"] = this["data"] || []),
              this["data"]["push"](_0x4b95a0);
          else {
            const _0xea39ff = this["subdivide"]();
            for (var _0x4974b1 = 0x0; _0x4974b1 < 0x8; ++_0x4974b1) {
              _0xea39ff[_0x4974b1]["insertFace"](
                _0x4b95a0,
                _0x52a133,
                _0x270f16 - 0x1,
                _0x27b1e9
              );
            }
            var _0x1a1d8c = new FaceHelper(_0x52a133["g"]);
            for (
              var _0x503bd4 = 0x0;
              _0x503bd4 < this["data"]["length"];
              ++_0x503bd4
            ) {
              _0x1a1d8c["computeFaceHelper"](this["data"][_0x503bd4]);
              for (var _0x4974b1 = 0x0; _0x4974b1 < 0x8; ++_0x4974b1) {
                _0xea39ff[_0x4974b1]["insertFace"](
                  this["data"][_0x503bd4],
                  _0x1a1d8c,
                  _0x270f16 - 0x1,
                  _0x27b1e9
                );
              }
            }
            this["data"] = undefined;
          }
        }
      }
    }
  }
  ["raycast"] = (function () {
    const hit = new Vector3(),
      recRaycast = function (ray, cell, intersects, max_level) {
        if (max_level === 0x0) {
          intersects["push"](cell);
          return;
        }
        cell["data"] &&
          cell["data"]["length"] !== 0x0 &&
          max_level <= -0x1 &&
          intersects["push"](cell);
        if (cell["children"]) {
          const order = [];
          for (let i = 0x0; i < 0x8; ++i) {
            order["push"]({ d: Number["MAX_VALUE"], c: cell["children"][i] }),
              ray["intersectBox"](cell["children"][i], hit)
                ? (order[i]["d"] = hit["sub"](ray["origin"])["lengthSq"]())
                : (order[i]["d"] = Number["MAX_VALUE"]);
          }
          order["sort"](function (a, b) {
            return a["d"] - b["d"];
          });
          for (let i = 0x0; i < 0x8; ++i) {
            order[i]["d"] !== Number["MAX_VALUE"] &&
              recRaycast(ray, order[i]["c"], intersects, max_level - 0x1);
          }
        }
      };
    return function (ray, intersects, max_level = -0x1) {
      ray["intersectsBox"](this) &&
        recRaycast(ray, this, intersects, max_level);
    };
  })();
}
class Box3Serializer {
  static ["toWorkerData"] = function (_0x58922e) {
    const _0x1c1d25 = {
      metadata: {
        type: "Box3WorkerData",
        generator: "Box3Serializer.toWorkerData"
      },
      data: {
        min: {
          x: _0x58922e["min"]["x"],
          y: _0x58922e["min"]["y"],
          z: _0x58922e["min"]["z"]
        },
        max: {
          x: _0x58922e["max"]["x"],
          y: _0x58922e["max"]["y"],
          z: _0x58922e["max"]["z"]
        }
      }
    };
    return _0x1c1d25;
  };
  static ["fromWorkerData"] = function (_0x11df72) {
    if (_0x11df72["metadata"]["type"] != "Box3WorkerData")
      throw "Box3Serializer:\x20data\x20is\x20not\x20of\x20type\x20Box3WorkerData";
    const _0x44409d = new Box3();
    return (
      _0x44409d["min"]["set"](
        _0x11df72["data"]["min"]["x"],
        _0x11df72["data"]["min"]["y"],
        _0x11df72["data"]["min"]["z"]
      ),
      _0x44409d["max"]["set"](
        _0x11df72["data"]["max"]["x"],
        _0x11df72["data"]["max"]["y"],
        _0x11df72["data"]["max"]["z"]
      ),
      _0x44409d
    );
  };
}
const cloneNumberArray = function (_0x1c39b0) {
  return _0x1c39b0["slice"](0x0, _0x1c39b0["length"]);
};
class OctreeLightSerializer {
  static ["toWorkerData"](_0x5b29e8) {
    function _0x461ad2(_0x4db767) {
      if (_0x4db767["children"]) {
        const _0x542be7 = [];
        for (var _0x19e737 = 0x0; _0x19e737 < 0x8; ++_0x19e737) {
          const _0x4c16b9 = _0x461ad2(_0x4db767["children"][_0x19e737]);
          _0x4c16b9 && _0x542be7["push"](_0x4c16b9);
        }
        return _0x542be7;
      } else
        return _0x4db767["data"] === undefined
          ? []
          : cloneNumberArray(_0x4db767["data"]);
    }
    return {
      metadata: {
        type: "OctreeLightWorkerData",
        generator: "OctreeLightSerializer.toWorkerData"
      },
      data: {
        box: Box3Serializer["toWorkerData"](_0x5b29e8),
        cells: _0x461ad2(_0x5b29e8),
        maxLevel: _0x5b29e8["maxLevel"]
      }
    };
  }
  static ["fromWorkerData"](_0x457627) {
    if (_0x457627["metadata"]["type"] != "OctreeLightWorkerData")
      throw "OctreeLightSerializer:\x20data\x20is\x20not\x20of\x20type\x20OctreeLightWorkerData";
    function _0x35f39a(_0x3c525c, _0x2227fe) {
      if (_0x2227fe) {
        if (_0x2227fe["length"] === 0x8 && typeof _0x2227fe[0x0] !== "number") {
          _0x3c525c["subdivide"]();
          for (var _0x1e1a58 = 0x0; _0x1e1a58 < 0x8; ++_0x1e1a58) {
            _0x35f39a(_0x3c525c["children"][_0x1e1a58], _0x2227fe[_0x1e1a58]);
          }
        } else _0x3c525c["data"] = _0x2227fe["slice"](0x0, _0x2227fe["length"]);
      }
      return _0x3c525c;
    }
    const _0x56bbef = Box3Serializer["fromWorkerData"](
        _0x457627["data"]["box"]
      ),
      _0x1cd3b3 = new OctreeLight(
        _0x56bbef["min"],
        _0x56bbef["max"],
        _0x457627["data"]["maxLevel"]
      );
    return _0x35f39a(_0x1cd3b3, _0x457627["data"]["cells"]);
  }
}
class OctreeBufferGeometry extends BufferGeometry {
  #octree = null;
  get ["octree"]() {
    return this.#octree;
  }
  ["copy"](_0x3dc20a) {
    super["copy"](_0x3dc20a);
    if (_0x3dc20a instanceof OctreeBufferGeometry)
      this.#octree = _0x3dc20a["octree"]
        ? new OctreeLight()["copy"](_0x3dc20a["octree"])
        : null;
    return this;
  }
  ["initializeOctree"]() {
    this["computeBoundingBox"](), this["computeBoundingSphere"]();
    if (this["boundingBox"]) {
      this.#octree = new OctreeLight()["copy"](this["boundingBox"]);
      const _0x4368b7 = this["index"]
        ? this["index"]["count"] / 0x3
        : this["attributes"]["position"]["count"] / 0x3;
      if (_0x4368b7 > 0x7d00)
        this.#octree["buildFromBufferGeometry"](this, 0x5, 0x8);
      else {
        if (_0x4368b7 > 0x1000)
          this.#octree["buildFromBufferGeometry"](this, 0x4, 0x8);
        else {
          if (_0x4368b7 > 0x200)
            this.#octree["buildFromBufferGeometry"](this, 0x3, 0x8);
          else {
            if (_0x4368b7 > 0x40)
              this.#octree["buildFromBufferGeometry"](this, 0x2, 0x8);
            else
              _0x4368b7 > 0x8
                ? this.#octree["buildFromBufferGeometry"](this, 0x1, 0x8)
                : this.#octree["buildFromBufferGeometry"](this, 0x0, 0x8);
          }
        }
      }
    }
  }
  ["clearOctree"]() {
    this.#octree = null;
  }
  ["_hasOctree"]() {
    return this.#octree !== null;
  }
  ["_raycastOctreeFaceList"](_0x2d732c) {
    if (this.#octree) {
      const _0xdf9bb7 = [];
      this.#octree["raycast"](_0x2d732c, _0xdf9bb7);
      const _0x29ff73 = {},
        _0xb5a3e9 = [];
      for (var _0x40c744 = 0x0; _0x40c744 < _0xdf9bb7["length"]; ++_0x40c744) {
        const _0xebd734 = _0xdf9bb7[_0x40c744];
        if (_0xebd734["data"])
          for (
            var _0x546401 = 0x0;
            _0x546401 < _0xebd734["data"]["length"];
            ++_0x546401
          ) {
            var _0x4ff6ee = _0xebd734["data"][_0x546401];
            !_0x29ff73[_0x4ff6ee] &&
              (_0xb5a3e9["push"](_0x4ff6ee), (_0x29ff73[_0x4ff6ee] = !![]));
          }
      }
      return _0xb5a3e9;
    } else
      return (
        console["warn"](
          "_raycastOctreeFaceList\x20should\x20not\x20be\x20called\x20if\x20this.#octree\x20is\x20null"
        ),
        []
      );
  }
  ["_raycastOctreeCell"](_0x214ced, _0x394b13) {
    if (this.#octree) {
      var _0x2efc44 = [];
      return (
        this.#octree["raycast"](_0x214ced, _0x2efc44, _0x394b13), _0x2efc44
      );
    } else
      return (
        console["warn"](
          "_raycastOctreeCell\x20should\x20not\x20be\x20called\x20if\x20this.#octree\x20is\x20null"
        ),
        []
      );
  }
  ["_fromWorkerData"](_0x533ab5, _0x3f432b) {
    const _0x2c27ed = BufferGeometrySerializer["fromWorkerData"](_0x533ab5);
    this["copy"](_0x2c27ed);
    if (_0x3f432b)
      this.#octree = OctreeLightSerializer["fromWorkerData"](_0x3f432b);
  }
}
class OctreeBufferGeometrySerializer {
  static ["toWorkerData"](_0x241339) {
    const _0x51fa15 = {
      metadata: {
        type: "OctreeBufferGeometryWorkerData",
        generator: "OctreeBufferGeometrySerializer.toWorkerData"
      },
      data: {
        bufferGeometry: BufferGeometrySerializer["toWorkerData"](_0x241339),
        octree: _0x241339["octree"]
          ? OctreeLightSerializer["toWorkerData"](_0x241339["octree"])
          : undefined
      }
    };
    return _0x51fa15;
  }
  static ["fromWorkerData"](_0x389c3f) {
    if (_0x389c3f["metadata"]["type"] != "OctreeBufferGeometryWorkerData")
      throw "OctreeBufferGeometrySerializer:\x20data\x20is\x20not\x20of\x20type\x20OctreeBufferGeometry";
    const _0x31175e = new OctreeBufferGeometry();
    return (
      _0x31175e["_fromWorkerData"](
        _0x389c3f["data"]["bufferGeometry"],
        _0x389c3f["data"]["octree"]
      ),
      _0x31175e
    );
  }
  static ["getTransferables"](_0x406598) {
    if (_0x406598["metadata"]["type"] != "OctreeBufferGeometryWorkerData")
      throw "OctreeBufferGeometrySerializer:\x20data\x20is\x20not\x20of\x20type\x20OctreeBufferGeometry";
    return BufferGeometrySerializer["getTransferables"](
      _0x406598["data"]["bufferGeometry"]
    );
  }
}
const vertexShader = [
    "attribute\x20vec3\x20barycentric;",
    "varying\x20vec3\x20vTestNormal;",
    "varying\x20vec3\x20vPosition;",
    "varying\x20vec3\x20vBarycentric;",
    "void\x20main()",
    "{",
    "\x20\x20\x20vec3\x20vNormal\x20=\x20normalize(normalMatrix\x20*\x20normal);",
    "\x20\x20\x20vPosition\x20=\x20position;",
    "\x20\x20\x20vTestNormal\x20=\x20normal;",
    "\x20\x20\x20vBarycentric\x20=\x20barycentric;",
    "\x20\x20\x20gl_Position\x20=\x20projectionMatrix\x20*\x20modelViewMatrix\x20*\x20vec4(position,\x201.0);",
    "}"
  ]["join"]("\x0a"),
  fragmentShader = [
    "uniform\x20float\x20opacity;",
    "uniform\x20float\x20lineWidth;",
    "uniform\x20vec3\x20color;",
    "uniform\x20vec3\x20lineColor;",
    "varying\x20vec3\x20vTestNormal;",
    "varying\x20vec3\x20vPosition;",
    "varying\x20vec3\x20vBarycentric;",
    "\x20\x20\x20float\x20edgeFactor(vec3\x20vBarycentric){\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20",
    "\x20\x20\x20\x20\x20\x20\x20vec3\x20d\x20=\x20lineWidth*fwidth(vBarycentric);\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20",
    "\x20\x20\x20\x20\x20\x20\x20vec3\x20a3\x20=\x20smoothstep(vec3(0.0),\x20d,\x20vBarycentric);\x20\x20\x20",
    "\x20\x20\x20\x20\x20\x20\x20return\x20min(min(a3.x,\x20a3.y),\x20a3.z);\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20\x20",
    "\x20\x20\x20}",
    "void\x20main()",
    "{",
    "\x20\x20\x20\x20gl_FragColor\x20=\x20mix(vec4(lineColor,1.0),\x20vec4(color,opacity),\x20edgeFactor(vBarycentric));\x20",
    "}"
  ]["join"]("\x0a");
class MeshWireframeMaterial extends ShaderMaterial {
  constructor(_0x3a84f0) {
    super({
      uniforms: UniformsUtils["merge"]([
        ShaderLib["normal"]["uniforms"],
        {
          opacity: { type: "f", value: _0x3a84f0["opacity"] },
          lineWidth: { type: "f", value: _0x3a84f0["lineWidth"] },
          color: { type: "c", value: _0x3a84f0["color"] },
          lineColor: { type: "c", value: _0x3a84f0["lineColor"] }
        }
      ]),
      vertexShader: vertexShader,
      fragmentShader: fragmentShader
    }),
      (this["extensions"]["derivatives"] = !![]),
      (this["opacity"] = _0x3a84f0["opacity"]),
      (this["transparent"] = _0x3a84f0["opacity"] !== 0x1),
      (this["side"] = _0x3a84f0["side"]);
  }
}
function getObjectsIntersections(_0x3f6a08, _0x4c83f0, _0x4dea0e = !![]) {
  let _0x499898 = new Raycaster(_0x3f6a08["origin"], _0x3f6a08["direction"]);
  return _0x499898["intersectObjects"](_0x4c83f0, _0x4dea0e);
}
function raycastOctreeMesh(_0x42bf86, _0x46215d, _0x5c491a, _0x180e29) {
  let _0x385ced = new Matrix4(),
    _0x7bf420 = new Ray(),
    _0x15ef03 = new Sphere(),
    _0x246827 = new Vector3(),
    _0x56ca99 = new Vector3(),
    _0x28bac9 = new Vector3();
  new Vector2(), new Vector2(), new Vector2();
  let _0x172ac9 = new Vector3(),
    _0x57fd22 = new Vector3();
  function _0x4703ba(
    _0x3d4789,
    _0x57a55a,
    _0x59e3e0,
    _0x400d49,
    _0x8fee03,
    _0x5ee5e1,
    _0x30b322,
    _0x2f2845
  ) {
    let _0x2d5de2;
    _0x57a55a["side"] === BackSide
      ? (_0x2d5de2 = _0x400d49["intersectTriangle"](
          _0x30b322,
          _0x5ee5e1,
          _0x8fee03,
          !![],
          _0x2f2845
        ))
      : (_0x2d5de2 = _0x400d49["intersectTriangle"](
          _0x8fee03,
          _0x5ee5e1,
          _0x30b322,
          _0x57a55a["side"] !== DoubleSide,
          _0x2f2845
        ));
    if (_0x2d5de2 === null) return null;
    _0x57fd22["copy"](_0x2f2845),
      _0x3d4789["updateMatrixWorld"](),
      _0x57fd22["applyMatrix4"](_0x3d4789["matrixWorld"]);
    var _0x273122 = _0x59e3e0["ray"]["origin"]["distanceTo"](_0x57fd22);
    if (_0x273122 < _0x59e3e0["near"] || _0x273122 > _0x59e3e0["far"])
      return null;
    return {
      distance: _0x273122,
      point: _0x57fd22["clone"](),
      object: _0x3d4789
    };
  }
  function _0x12d414(
    _0x4c7182,
    _0x2bc6fa,
    _0x1751ce,
    _0x2f5db2,
    _0x3ea5e9,
    _0xdc509e,
    _0x36fb56,
    _0x29e811,
    _0x4993f3
  ) {
    _0x246827["fromBufferAttribute"](_0x3ea5e9, _0x36fb56),
      _0x56ca99["fromBufferAttribute"](_0x3ea5e9, _0x29e811),
      _0x28bac9["fromBufferAttribute"](_0x3ea5e9, _0x4993f3);
    var _0x3ed4b4 = _0x4703ba(
      _0x4c7182,
      _0x2bc6fa,
      _0x1751ce,
      _0x2f5db2,
      _0x246827,
      _0x56ca99,
      _0x28bac9,
      _0x172ac9
    );
    if (_0x3ed4b4) {
      const _0x581ff2 = {
        a: _0x36fb56,
        b: _0x29e811,
        c: _0x4993f3,
        normal: new Vector3(),
        materialIndex: 0x0
      };
      Triangle["getNormal"](
        _0x246827,
        _0x56ca99,
        _0x28bac9,
        _0x581ff2["normal"]
      ),
        (_0x3ed4b4["face"] = _0x581ff2);
    }
    return _0x3ed4b4;
  }
  const _0x4ec304 = _0x46215d,
    _0xea26cf = _0x42bf86["material"],
    _0xe79f8d = _0x42bf86["matrixWorld"];
  if (_0xea26cf === undefined) return;
  if (_0x4ec304["boundingSphere"] === null)
    _0x4ec304["computeBoundingSphere"]();
  if (_0x4ec304["boundingSphere"] !== null)
    _0x15ef03["copy"](_0x4ec304["boundingSphere"]);
  _0x15ef03["applyMatrix4"](_0xe79f8d);
  if (_0x5c491a["ray"]["intersectsSphere"](_0x15ef03) === ![]) return;
  (_0x385ced = _0xe79f8d["invert"]()),
    _0x7bf420["copy"](_0x5c491a["ray"])["applyMatrix4"](_0x385ced);
  if (_0x4ec304["boundingBox"] !== null) {
    var _0x4cef62 = new Vector3();
    if (_0x7bf420["intersectBox"](_0x4ec304["boundingBox"], _0x4cef62) === null)
      return;
    else {
      if (_0x42bf86["raycastBoundingOnly"]) {
        _0x57fd22["copy"](_0x4cef62),
          _0x57fd22["applyMatrix4"](_0x42bf86["matrixWorld"]);
        var _0x2871d0 = _0x5c491a["ray"]["origin"]["distanceTo"](_0x57fd22);
        if (_0x2871d0 < _0x5c491a["near"] || _0x2871d0 > _0x5c491a["far"])
          return null;
        _0x180e29["push"]({
          distance: _0x2871d0,
          point: _0x57fd22["clone"](),
          object: _0x42bf86
        });
        return;
      }
    }
  }
  if (
    _0xea26cf instanceof Array ||
    !(_0x4ec304 instanceof OctreeBufferGeometry) ||
    !_0x4ec304["octree"]
  )
    return _0x42bf86 instanceof SkinnedMesh
      ? _0x42bf86["raycast"](_0x5c491a, _0x180e29)
      : _0x42bf86["raycast"](_0x5c491a, _0x180e29);
  var _0x4fe334,
    _0x26c8e4,
    _0x1e27ef,
    _0x162cd0,
    _0x103e87 = _0x4ec304["index"],
    _0x2faf21 = _0x4ec304["attributes"]["position"],
    _0x84635d = _0x4ec304["attributes"]["uv"];
  if (_0x42bf86["raycast_max_level"] >= 0x0) {
    var _0x53caf8 = Math["min"](
        _0x42bf86["raycast_max_level"],
        _0x4ec304["octree"]["maxLevel"]
      ),
      _0x2169de = _0x4ec304["_raycastOctreeCell"](_0x7bf420, _0x53caf8);
    if (_0x2169de["length"] !== 0x0) {
      var _0x2848af = new Vector3(),
        _0x3a3159 = new Vector3(),
        _0x462cdf = Number["MAX_VALUE"],
        _0x18433b = Number["MAX_VALUE"];
      for (var _0x51d670 of _0x2169de) {
        _0x7bf420["intersectBox"](_0x51d670, _0x2848af) !== null &&
          ((_0x18433b = _0x7bf420["origin"]["distanceTo"](_0x2848af)),
          _0x18433b < _0x462cdf &&
            ((_0x462cdf = _0x18433b), _0x3a3159["copy"](_0x2848af)));
      }
      _0x42bf86["updateMatrixWorld"](),
        _0x3a3159["applyMatrix4"](_0x42bf86["matrixWorld"]),
        _0x180e29["push"]({
          distance: _0x462cdf,
          point: _0x3a3159["clone"](),
          object: _0x42bf86
        });
    }
  } else {
    if (_0x103e87 !== null) {
      var _0x2a4939 = _0x4ec304["_raycastOctreeFaceList"](_0x7bf420);
      for (let _0x3ca6dd = 0x0; _0x3ca6dd < _0x2a4939["length"]; _0x3ca6dd++) {
        let _0x13e4cc = _0x2a4939[_0x3ca6dd] * 0x3;
        (_0x26c8e4 = _0x103e87["getX"](_0x13e4cc)),
          (_0x1e27ef = _0x103e87["getX"](_0x13e4cc + 0x1)),
          (_0x162cd0 = _0x103e87["getX"](_0x13e4cc + 0x2)),
          (_0x4fe334 = _0x12d414(
            _0x42bf86,
            _0xea26cf,
            _0x5c491a,
            _0x7bf420,
            _0x2faf21,
            _0x84635d,
            _0x26c8e4,
            _0x1e27ef,
            _0x162cd0
          )),
          _0x4fe334 &&
            ((_0x4fe334["faceIndex"] = Math["floor"](_0x13e4cc / 0x3)),
            _0x180e29["push"](_0x4fe334));
      }
    } else {
      if (_0x2faf21 !== undefined) {
        var _0x2a4939 = _0x4ec304["_raycastOctreeFaceList"](_0x7bf420);
        for (
          let _0x32f7cb = 0x0;
          _0x32f7cb < _0x2a4939["length"];
          _0x32f7cb++
        ) {
          let _0x450a93 = _0x2a4939[_0x32f7cb] * 0x3;
          (_0x26c8e4 = _0x450a93),
            (_0x1e27ef = _0x450a93 + 0x1),
            (_0x162cd0 = _0x450a93 + 0x2),
            (_0x4fe334 = _0x12d414(
              _0x42bf86,
              _0xea26cf,
              _0x5c491a,
              _0x7bf420,
              _0x2faf21,
              _0x84635d,
              _0x26c8e4,
              _0x1e27ef,
              _0x162cd0
            )),
            _0x4fe334 &&
              ((_0x4fe334["faceIndex"] = _0x450a93 / 0x3),
              _0x180e29["push"](_0x4fe334));
        }
      }
    }
  }
}
function approximateMultiMeshVolume(_0xc81176, _0x46121f) {
  const _0x1ac01a = new Box3()["setFromObject"](_0xc81176),
    _0x3274d7 = new Map(),
    _0x428a9c = [];
  _0xc81176["traverse"]((_0x5447cc) => {
    _0x5447cc instanceof Mesh &&
      (_0x428a9c["push"](_0x5447cc),
      _0x5447cc["material"]["side"] !== undefined &&
        _0x3274d7["set"](_0x5447cc, _0x5447cc["material"]["side"]),
      (_0x5447cc["material"]["side"] = DoubleSide));
  });
  const _0x3bac6b = new Raycaster(new Vector3(), new Vector3(0x0, 0x0, 0x1)),
    _0x54c685 = [];
  let _0x58b552 = 0x0;
  for (
    let _0x4b63d3 = _0x1ac01a["min"]["x"] - _0x46121f / 0x2;
    _0x4b63d3 < _0x1ac01a["max"]["x"] + _0x46121f / 0x2;
    _0x4b63d3 += _0x46121f
  ) {
    for (
      let _0x26150f = _0x1ac01a["min"]["y"];
      _0x26150f < _0x1ac01a["max"]["y"];
      _0x26150f += _0x46121f
    ) {
      _0x3bac6b["ray"]["origin"]["set"](
        _0x4b63d3,
        _0x26150f,
        _0x1ac01a["min"]["z"] - _0x46121f / 0x2
      ),
        (_0x54c685["length"] = 0x0),
        _0x3bac6b["intersectObjects"](_0x428a9c, !![], _0x54c685);
      if (_0x54c685["length"]) {
        let _0x5631a0 = 0x1,
          _0x35aa75 = _0x54c685[0x0]["distance"],
          _0x1adfd4 = 0x0;
        for (let _0xe46d6 = 0x1; _0xe46d6 < _0x54c685["length"]; ++_0xe46d6) {
          const _0x2a6816 = _0x54c685[_0xe46d6]["distance"],
            _0x2b3321 =
              (_0x54c685[_0xe46d6]["face"]?.["normal"]["z"] || 0x0) <= 0x0;
          _0x5631a0 > 0x0 && (_0x1adfd4 += _0x2a6816 - _0x35aa75),
            _0x2b3321 ? (_0x5631a0 += 0x1) : (_0x5631a0 -= 0x1),
            (_0x35aa75 = _0x2a6816);
        }
        _0x58b552 += _0x1adfd4;
      }
    }
  }
  return (
    _0x428a9c["forEach"]((_0x2a6e71) => {
      _0x2a6e71["material"] instanceof Material &&
        (_0x2a6e71["material"]["side"] =
          _0x3274d7["get"](_0x2a6e71) || _0x2a6e71["material"]["side"]);
    }),
    _0x58b552 * _0x46121f * _0x46121f
  );
}
const resizeArrayBuffer = function (_0x11a510, _0x4b8865) {
  const _0x5774a4 = [
    Float32Array,
    Float64Array,
    Int16Array,
    Int32Array,
    Int8Array,
    Uint8Array,
    Uint16Array,
    Uint32Array,
    Uint8ClampedArray
  ];
  for (let _0x57ec58 = 0x0; _0x57ec58 < _0x5774a4["length"]; _0x57ec58++) {
    let _0x501869 = _0x5774a4[_0x57ec58];
    if (_0x11a510 instanceof _0x501869) {
      if (_0x11a510["length"] >= _0x4b8865)
        return _0x11a510["slice"]
          ? _0x11a510["slice"](0x0, _0x4b8865)
          : new _0x501869(_0x11a510["subarray"](0x0, _0x4b8865));
      else {
        let _0x5c07db = new _0x501869(_0x4b8865);
        return _0x5c07db["set"](_0x11a510), _0x5c07db;
      }
    }
  }
  if (_0x11a510["constructor"] && _0x11a510["constructor"]["name"])
    throw (
      "Unknown\x20ArrayBuffer\x20Type:\x20" + _0x11a510["constructor"]["name"]
    );
  else throw "Unknown\x20ArrayBuffer\x20Type";
};
class BufferGeometryUtils {
  static ["mergeVerticesPass"](
    _0x45779a,
    _0x2a6618 = 0.0001,
    _0x3bada0 = 0x0,
    _0x4577bb
  ) {
    _0x2a6618 = Math["max"](_0x2a6618, Number["EPSILON"]);
    const _0x5a2bb2 = {},
      _0x269433 = new Map(),
      _0x2f7dcf = _0x45779a["getIndex"](),
      _0x358804 = _0x45779a["getAttribute"]("position"),
      _0x34105c = _0x2f7dcf ? _0x2f7dcf["count"] : _0x358804["count"];
    let _0x10014d = 0x0;
    const _0x2b4855 = Object["keys"](_0x45779a["attributes"]),
      _0xfea07b = {},
      _0x4721aa = {},
      _0x27812e = new Set(),
      _0x54b84b = [],
      _0x5dff56 = ["getX", "getY", "getZ", "getW"];
    for (
      let _0x3569e9 = 0x0, _0x297a4 = _0x2b4855["length"];
      _0x3569e9 < _0x297a4;
      _0x3569e9++
    ) {
      const _0x380ad6 = _0x2b4855[_0x3569e9];
      _0xfea07b[_0x380ad6] = [];
      const _0x52ed1c = _0x45779a["morphAttributes"][_0x380ad6];
      _0x52ed1c &&
        (_0x4721aa[_0x380ad6] = new Array(_0x52ed1c["length"])["fill"]([]));
    }
    const _0x2e1917 = Math["log10"](0x1 / _0x2a6618),
      _0x3d523f = Math["pow"](0xa, _0x2e1917);
    for (let _0x2dc3f2 = 0x0; _0x2dc3f2 < _0x34105c; _0x2dc3f2++) {
      const _0xb4bb3 = _0x2f7dcf ? _0x2f7dcf["getX"](_0x2dc3f2) : _0x2dc3f2;
      let _0x326c0b = _0x269433["get"](_0xb4bb3) || "";
      if (_0x326c0b === "")
        for (
          let _0x212b80 = 0x0, _0x96b5ac = _0x2b4855["length"];
          _0x212b80 < _0x96b5ac;
          _0x212b80++
        ) {
          const _0x59af5e = _0x2b4855[_0x212b80],
            _0x4d9590 = _0x45779a["getAttribute"](_0x59af5e),
            _0x5391d0 = _0x4d9590["itemSize"];
          for (let _0x2053d5 = 0x0; _0x2053d5 < _0x5391d0; _0x2053d5++) {
            _0x326c0b +=
              ~~(
                (_0x4d9590[_0x5dff56[_0x2053d5]](_0xb4bb3) + _0x3bada0) *
                _0x3d523f
              ) + ",";
          }
        }
      if (_0x326c0b in _0x5a2bb2)
        _0x54b84b["push"](_0x5a2bb2[_0x326c0b]),
          !_0x269433["has"](_0xb4bb3) && _0x27812e["add"](_0x5a2bb2[_0x326c0b]);
      else {
        for (
          let _0x5a09a6 = 0x0, _0xe8cb70 = _0x2b4855["length"];
          _0x5a09a6 < _0xe8cb70;
          _0x5a09a6++
        ) {
          const _0x20a2d8 = _0x2b4855[_0x5a09a6],
            _0x16e6b0 = _0x45779a["getAttribute"](_0x20a2d8),
            _0x4084fe = _0x45779a["morphAttributes"][_0x20a2d8],
            _0x486cac = _0x16e6b0["itemSize"],
            _0x32d871 = _0xfea07b[_0x20a2d8],
            _0xdcf3f = _0x4721aa[_0x20a2d8];
          for (let _0x539663 = 0x0; _0x539663 < _0x486cac; _0x539663++) {
            const _0x56cf4c = _0x5dff56[_0x539663];
            _0x32d871["push"](_0x16e6b0[_0x56cf4c](_0xb4bb3));
            if (_0x4084fe)
              for (
                let _0x37e903 = 0x0, _0x2cf9d6 = _0x4084fe["length"];
                _0x37e903 < _0x2cf9d6;
                _0x37e903++
              ) {
                _0xdcf3f[_0x37e903]["push"](
                  _0x4084fe[_0x37e903][_0x56cf4c](_0xb4bb3)
                );
              }
          }
        }
        _0x269433["set"](_0xb4bb3, _0x326c0b),
          (_0x5a2bb2[_0x326c0b] = _0x10014d),
          _0x54b84b["push"](_0x10014d),
          _0x4577bb?.["has"](_0xb4bb3) && _0x27812e["add"](_0x10014d),
          _0x10014d++;
      }
    }
    const _0x3426ba = _0x45779a["clone"]();
    for (
      let _0x2f04be = 0x0, _0x2a21d1 = _0x2b4855["length"];
      _0x2f04be < _0x2a21d1;
      _0x2f04be++
    ) {
      const _0x2891ec = _0x2b4855[_0x2f04be],
        _0x17b12c = _0x45779a["getAttribute"](_0x2891ec),
        _0xb1bcc1 = new _0x17b12c["array"]["constructor"](_0xfea07b[_0x2891ec]),
        _0xc10636 = new BufferAttribute(
          _0xb1bcc1,
          _0x17b12c["itemSize"],
          _0x17b12c["normalized"]
        );
      _0x3426ba["setAttribute"](_0x2891ec, _0xc10636);
      if (_0x2891ec in _0x4721aa)
        for (
          let _0x290e50 = 0x0;
          _0x290e50 < _0x4721aa[_0x2891ec]["length"];
          _0x290e50++
        ) {
          const _0xa34120 = _0x45779a["morphAttributes"][_0x2891ec][_0x290e50],
            _0x39dd40 = new _0xa34120["array"]["constructor"](
              _0x4721aa[_0x2891ec][_0x290e50]
            ),
            _0x12ad0f = new BufferAttribute(
              _0x39dd40,
              _0xa34120["itemSize"],
              _0xa34120["normalized"]
            );
          _0x3426ba["morphAttributes"][_0x2891ec][_0x290e50] = _0x12ad0f;
        }
    }
    return (
      _0x3426ba["setIndex"](_0x54b84b),
      { mergedGeometry: _0x3426ba, mergedVertices: _0x27812e }
    );
  }
  static ["mergeVertices"](_0x5b8940, _0x3b0aa3 = 0.0001, _0x15328b) {
    const _0x393900 = BufferGeometryUtils["mergeVerticesPass"](
        _0x5b8940,
        _0x3b0aa3,
        0x0
      ),
      _0x469831 = BufferGeometryUtils["mergeVerticesPass"](
        _0x393900["mergedGeometry"],
        _0x3b0aa3,
        _0x3b0aa3 / 0x2,
        _0x393900["mergedVertices"]
      ),
      _0x338732 = (_0x19e5ac, _0x20d4e0) => {
        return _0x19e5ac <= _0x20d4e0
          ? _0x19e5ac + "-" + _0x20d4e0
          : _0x20d4e0 + "-" + _0x19e5ac;
      },
      _0x44dff0 = (_0x3f08d0, _0x3f951f, _0x2840e6) => {
        if (_0x3f08d0 <= _0x3f951f) {
          if (_0x3f951f <= _0x2840e6)
            return _0x3f08d0 + "-" + _0x3f951f + "-" + _0x2840e6;
          else
            return _0x2840e6 <= _0x3f08d0
              ? _0x2840e6 + "-" + _0x3f08d0 + "-" + _0x3f951f
              : _0x3f08d0 + "-" + _0x2840e6 + "-" + _0x3f951f;
        } else {
          if (_0x2840e6 <= _0x3f951f)
            return _0x2840e6 + "-" + _0x3f951f + "-" + _0x3f08d0;
          else
            return _0x3f08d0 <= _0x2840e6
              ? _0x3f951f + "-" + _0x3f08d0 + "-" + _0x2840e6
              : _0x3f951f + "-" + _0x2840e6 + "-" + _0x3f08d0;
        }
      },
      _0x38560d = _0x469831["mergedGeometry"]["getIndex"]()?.["array"];
    if (_0x15328b && _0x38560d) {
      const _0x456782 = new Set(),
        _0x45d1ec = new Map(),
        _0x24b06d = (_0x589d79, _0x12083a, _0x4834ff) => {
          const _0x489dfb = _0x338732(_0x589d79, _0x12083a);
          let _0x3bb164 = _0x45d1ec["get"](_0x489dfb) || [];
          _0x3bb164["push"](_0x4834ff), _0x45d1ec["set"](_0x489dfb, _0x3bb164);
        },
        _0x3576e7 = new Map(),
        _0x13792e = (_0x389d9f, _0x245735, _0x27d479, _0x4d01d5) => {
          const _0x18a9fd = _0x44dff0(_0x389d9f, _0x245735, _0x27d479);
          let _0x4fdb88 = _0x3576e7["get"](_0x18a9fd) || [];
          return (
            _0x4fdb88["push"](_0x4d01d5),
            _0x3576e7["set"](_0x18a9fd, _0x4fdb88),
            _0x4fdb88
          );
        },
        _0x3dbad0 = _0x38560d["length"] / 0x3;
      for (let _0x12bf6b = 0x0; _0x12bf6b < _0x3dbad0; _0x12bf6b++) {
        const _0xd4c52 = _0x38560d[_0x12bf6b * 0x3],
          _0x324b60 = _0x38560d[_0x12bf6b * 0x3 + 0x1],
          _0x2429e7 = _0x38560d[_0x12bf6b * 0x3 + 0x2];
        _0x24b06d(_0xd4c52, _0x324b60, _0x12bf6b),
          _0x24b06d(_0x324b60, _0x2429e7, _0x12bf6b),
          _0x24b06d(_0x2429e7, _0xd4c52, _0x12bf6b);
        const _0x4c8c5c = _0x13792e(_0xd4c52, _0x324b60, _0x2429e7, _0x12bf6b);
        _0x4c8c5c["length"] > 0x1 &&
          _0x4c8c5c["forEach"]((_0x49c376) => {
            _0x456782["add"](_0x49c376);
          });
      }
      {
        const _0x2c9794 = (_0x183479, _0x1814d3, _0x1403a2) => {
          const _0x4a3809 =
              _0x45d1ec["get"](_0x338732(_0x183479, _0x1814d3))?.["length"] ||
              0x0,
            _0x3c0d00 =
              _0x45d1ec["get"](_0x338732(_0x1814d3, _0x1403a2))?.["length"] ||
              0x0,
            _0x42d186 =
              _0x45d1ec["get"](_0x338732(_0x1403a2, _0x183479))?.["length"] ||
              0x0,
            _0x5838ce =
              (_0x4a3809 > 0x2 ? 0x1 : 0x0) +
                (_0x3c0d00 > 0x2 ? 0x1 : 0x0) +
                (_0x42d186 > 0x2 ? 0x1 : 0x0) ===
              0x2;
          if (_0x5838ce) {
            if (_0x4a3809 === 0x2)
              return { a: _0x1403a2, b: _0x183479, c: _0x1814d3 };
            if (_0x3c0d00 === 0x2)
              return { a: _0x183479, b: _0x1814d3, c: _0x1403a2 };
            if (_0x42d186 === 0x2)
              return { a: _0x1403a2, b: _0x183479, c: _0x1814d3 };
          }
          return undefined;
        };
        _0x45d1ec["forEach"]((_0x5dd7f6) => {
          if (_0x5dd7f6["length"] <= 0x2) return;
          _0x5dd7f6["forEach"]((_0x47f499) => {
            if (_0x456782["has"](_0x47f499)) return;
            const _0x339000 = _0x2c9794(
              _0x38560d[_0x47f499 * 0x3],
              _0x38560d[_0x47f499 * 0x3 + 0x1],
              _0x38560d[_0x47f499 * 0x3 + 0x2]
            );
            if (!_0x339000) return;
            const _0x30e9a0 = (_0x1d4ac6) => {
                let _0x3c1288;
                for (
                  let _0x3befa6 = _0x1d4ac6 * 0x3;
                  _0x3befa6 < _0x1d4ac6 * 0x3 + 0x3;
                  ++_0x3befa6
                ) {
                  _0x3c1288 = _0x38560d[_0x3befa6];
                  if (
                    _0x3c1288 !== _0x339000["a"] &&
                    _0x3c1288 !== _0x339000["b"] &&
                    _0x3c1288 !== _0x339000["c"]
                  )
                    return _0x3c1288;
                }
                return undefined;
              },
              _0x5dbb20 = _0x45d1ec["get"](
                _0x338732(_0x339000["b"], _0x339000["c"])
              );
            if (_0x5dbb20 && _0x5dbb20["length"] === 0x2) {
              const _0x48545d =
                  _0x5dbb20[0x0] === _0x47f499
                    ? _0x5dbb20[0x1]
                    : _0x5dbb20[0x0],
                _0x308bd0 = _0x30e9a0(_0x48545d);
              _0x308bd0 &&
                _0x3576e7["has"](
                  _0x44dff0(_0x339000["a"], _0x339000["b"], _0x308bd0)
                ) &&
                _0x3576e7["has"](
                  _0x44dff0(_0x339000["a"], _0x308bd0, _0x339000["b"])
                ) &&
                (_0x456782["add"](_0x47f499), _0x456782["add"](_0x48545d));
            }
          });
        });
      }
      const _0x20c504 = [];
      for (let _0x408e21 = 0x0; _0x408e21 < _0x3dbad0; _0x408e21++) {
        const _0x1b4790 = _0x38560d[_0x408e21 * 0x3],
          _0x3dd172 = _0x38560d[_0x408e21 * 0x3 + 0x1],
          _0x3ce877 = _0x38560d[_0x408e21 * 0x3 + 0x2];
        !_0x456782["has"](_0x408e21) &&
          _0x20c504["push"](_0x1b4790, _0x3dd172, _0x3ce877);
      }
      return (
        _0x469831["mergedGeometry"]["setIndex"](_0x20c504),
        _0x469831["mergedGeometry"]
      );
    } else return _0x469831["mergedGeometry"];
  }
  static ["deleteVertices"](_0x4c8acd, _0x39e771) {
    let _0x278704 = _0x4c8acd["getAttribute"]("position")["count"] || 0x0;
    const _0x2d2b45 = function _0x5fa6d0(_0x1acf02) {
        const _0x30ce47 = Object["keys"](_0x4c8acd["attributes"]);
        let _0x569c34, _0xb6c930, _0x5b9447;
        for (
          let _0x3caf76 = 0x0;
          _0x3caf76 < _0x30ce47["length"];
          _0x3caf76++
        ) {
          (_0x569c34 = _0x4c8acd["getAttribute"](_0x30ce47[_0x3caf76])),
            (_0xb6c930 = _0x569c34["array"]),
            (_0x5b9447 = _0x569c34["itemSize"]);
          for (let _0x3f4585 = 0x0; _0x3f4585 < _0x5b9447; _0x3f4585++) {
            (_0xb6c930[_0x5b9447 * _0x1acf02 + _0x3f4585] =
              _0xb6c930[_0x5b9447 * (_0x278704 - 0x1) + _0x3f4585]),
              (_0xb6c930[_0x5b9447 * (_0x278704 - 0x1) + _0x3f4585] = 0x0);
          }
        }
        _0x278704--;
      },
      _0x365824 = {};
    _0x39e771["forEach"](function (_0xece365) {
      if (_0x365824[_0xece365])
        throw "Error\x20:\x20varray\x20must\x20not\x20contain\x20twice\x20the\x20same\x20vertex\x20index.\x20PLease\x20remove\x20duplicates.";
      _0x365824[_0xece365] = !![];
    });
    const _0x3ea182 = _0x39e771["sort"](function (_0x1f544d, _0x2fba3f) {
        return _0x1f544d - _0x2fba3f;
      }),
      _0x3e8cfe = _0x4c8acd["index"]?.["array"];
    if (
      _0x3e8cfe &&
      !(_0x3e8cfe instanceof Uint32Array) &&
      !(_0x3e8cfe instanceof Uint16Array)
    )
      throw new Error(
        "three-js-extra\x20deleteVertices\x20expects\x20indices\x20to\x20be\x20Uint32Array\x20orUint16Array\x20"
      );
    let _0x57f1fc = null;
    if (!_0x3e8cfe)
      for (let _0x42c2a8 = 0x0; _0x42c2a8 < _0x3ea182["length"]; ++_0x42c2a8) {
        let _0x4f2cb9 = _0x3ea182[_0x42c2a8],
          _0x4a04fb = _0x278704 - 0x1;
        while (
          _0x365824[_0x4a04fb] ||
          _0x365824[_0x4a04fb - 0x1] ||
          (_0x365824[_0x4a04fb - 0x2] && _0x4a04fb >= _0x4f2cb9)
        ) {
          _0x2d2b45(_0x4a04fb),
            _0x2d2b45(_0x4a04fb - 0x1),
            _0x2d2b45(_0x4a04fb - 0x2),
            (_0x4a04fb = _0x278704 - 0x1);
        }
        if (_0x4f2cb9 < _0x278704 - 0x1) {
          let _0x279550 = _0x4f2cb9 % 0x3;
          _0x2d2b45(_0x279550 + 0x2),
            _0x2d2b45(_0x279550 + 0x1),
            _0x2d2b45(_0x279550);
        } else break;
      }
    else {
      let _0x1eafb6 = {};
      for (let _0x2691b1 = 0x0; _0x2691b1 < _0x3ea182["length"]; ++_0x2691b1) {
        let _0x440cde = _0x3ea182[_0x2691b1];
        while (_0x365824[_0x278704 - 0x1] && _0x278704 - 0x1 >= _0x440cde) {
          _0x2d2b45(_0x278704 - 0x1);
        }
        if (_0x440cde < _0x278704 - 0x1)
          (_0x1eafb6[_0x278704 - 0x1] = _0x440cde), _0x2d2b45(_0x440cde);
        else break;
      }
      Object["keys"](_0x1eafb6)["forEach"](function (_0x2980ed) {
        let _0x31747a = _0x1eafb6[_0x2980ed];
        while (_0x1eafb6[_0x31747a] !== undefined) {
          _0x31747a = _0x1eafb6[_0x31747a];
        }
        _0x1eafb6[_0x2980ed] = _0x31747a;
      }),
        (_0x57f1fc = _0x3e8cfe["length"] / 0x3);
      for (let _0x1f8285 = 0x0; _0x1f8285 < _0x57f1fc; ++_0x1f8285) {
        let _0x2da03d = _0x3e8cfe[0x3 * _0x1f8285 + 0x0],
          _0x46b30c = _0x3e8cfe[0x3 * _0x1f8285 + 0x1],
          _0x3d4fb5 = _0x3e8cfe[0x3 * _0x1f8285 + 0x2];
        _0x365824[_0x2da03d] || _0x365824[_0x46b30c] || _0x365824[_0x3d4fb5]
          ? ((_0x3e8cfe[0x3 * _0x1f8285 + 0x0] =
              _0x3e8cfe[0x3 * (_0x57f1fc - 0x1) + 0x0]),
            (_0x3e8cfe[0x3 * _0x1f8285 + 0x1] =
              _0x3e8cfe[0x3 * (_0x57f1fc - 0x1) + 0x1]),
            (_0x3e8cfe[0x3 * _0x1f8285 + 0x2] =
              _0x3e8cfe[0x3 * (_0x57f1fc - 0x1) + 0x2]),
            _0x3e8cfe["fill"](
              0x0,
              0x3 * (_0x57f1fc - 0x1),
              0x3 * (_0x57f1fc - 0x1) + 0x3
            ),
            _0x57f1fc--,
            _0x1f8285--)
          : (_0x1eafb6[_0x2da03d] !== undefined &&
              (_0x3e8cfe[0x3 * _0x1f8285 + 0x0] = _0x1eafb6[_0x2da03d]),
            _0x1eafb6[_0x46b30c] !== undefined &&
              (_0x3e8cfe[0x3 * _0x1f8285 + 0x1] = _0x1eafb6[_0x46b30c]),
            _0x1eafb6[_0x3d4fb5] !== undefined &&
              (_0x3e8cfe[0x3 * _0x1f8285 + 0x2] = _0x1eafb6[_0x3d4fb5]));
      }
    }
    BufferGeometryUtils["resizeBuffers"](_0x4c8acd, _0x278704, _0x57f1fc);
  }
  static ["resizeBuffers"](_0x353cba, _0x291f5b, _0x50b246) {
    _0x353cba["dispose"]();
    if (_0x291f5b !== null) {
      const _0x145c8a = Object["keys"](_0x353cba["attributes"]);
      for (let _0x21c878 = 0x0; _0x21c878 < _0x145c8a["length"]; ++_0x21c878) {
        let _0x84868e = _0x353cba["attributes"][_0x145c8a[_0x21c878]];
        _0x353cba["attributes"][_0x145c8a[_0x21c878]] = new BufferAttribute(
          resizeArrayBuffer(
            _0x84868e["array"],
            _0x291f5b * _0x84868e["itemSize"]
          ),
          _0x84868e["itemSize"]
        );
      }
    }
    let _0x5b3a31 = _0x353cba["index"];
    if (_0x5b3a31) {
      let _0x5b33d8 = _0x5b3a31["array"];
      if (
        _0x5b33d8 &&
        !(_0x5b33d8 instanceof Uint32Array) &&
        !(_0x5b33d8 instanceof Uint16Array)
      )
        throw new Error(
          "three-js-extra\x20deleteVertices\x20expects\x20indices\x20to\x20be\x20Uint32Array\x20orUint16Array\x20"
        );
      _0x50b246 !== null &&
        (_0x5b33d8 instanceof Uint16Array &&
          _0x353cba["attributes"]["position"]["count"] > 0xffff &&
          (_0x5b33d8 = new Uint32Array(_0x5b33d8)),
        (_0x353cba["index"] = new BufferAttribute(
          resizeArrayBuffer(_0x5b33d8, _0x50b246 * 0x3),
          _0x5b3a31["itemSize"]
        )));
    }
  }
  static ["cropVertices"](_0x51ae55, _0x49d67f) {
    const _0x8e50c1 = _0x51ae55["getAttribute"]("position"),
      _0x1cc69f = _0x8e50c1["count"],
      _0x10b205 = new Vector3(),
      _0x10eb35 = [];
    for (let _0x4ebd80 = 0x0; _0x4ebd80 < _0x1cc69f; ++_0x4ebd80) {
      _0x10b205["set"](
        _0x8e50c1["getX"](_0x4ebd80),
        _0x8e50c1["getY"](_0x4ebd80),
        _0x8e50c1["getZ"](_0x4ebd80)
      ),
        !_0x49d67f["containsPoint"](_0x10b205) && _0x10eb35["push"](_0x4ebd80);
    }
    BufferGeometryUtils["deleteVertices"](_0x51ae55, _0x10eb35);
  }
  static ["setBufferAttributeArray"](_0x20b577, _0xf82edb, _0x5ec0ce) {
    let _0x10e961 = _0x20b577["getAttribute"](_0xf82edb);
    if (
      !_0x10e961 ||
      _0x5ec0ce["length"] != _0x10e961["itemSize"] * _0x10e961["count"]
    ) {
      console["warn"](
        "Attribute\x20array\x20size\x20does\x20not\x20match\x20the\x20size\x20of\x20the\x20array\x20to\x20set"
      );
      return;
    }
    _0x10e961["array"]["set"](_0x5ec0ce), (_0x10e961["needsUpdate"] = !![]);
  }
  static ["deleteBufferAttributes"](_0x1d9e73) {
    for (let _0x429cb1 of Object["keys"](_0x1d9e73["attributes"])) {
      _0x1d9e73["deleteAttribute"](_0x429cb1);
    }
  }
  static ["getMorphedAttributes"](_0x534b2f, _0x3ce96c) {
    let _0x5d97c2 = (_0x28c489, _0x3f0d01, _0x4d8add) => {
        const _0xbb840e = [],
          _0x2513ca = [];
        _0xbb840e["push"](_0x28c489["getAttribute"](_0x3f0d01)["array"]),
          _0x2513ca["push"](0x1);
        if (_0x28c489["morphAttributes"][_0x3f0d01]) {
          let _0x126d3d = 0x0;
          for (
            let _0x1fe1e0 = 0x0;
            _0x1fe1e0 < _0x28c489["morphAttributes"][_0x3f0d01]["length"];
            _0x1fe1e0++
          ) {
            _0xbb840e["push"](
              _0x28c489["morphAttributes"][_0x3f0d01][_0x1fe1e0]["array"]
            ),
              _0x1fe1e0 >= _0x4d8add["length"]
                ? _0x2513ca["push"](0x0)
                : (_0x2513ca["push"](_0x4d8add[_0x1fe1e0]),
                  (_0x126d3d += _0x4d8add[_0x1fe1e0]));
          }
          if (_0x126d3d > 1.01)
            throw "Unwrapper:\x20Total\x20morph\x20target\x20influence\x20is\x20greater\x20than\x201";
          _0x2513ca[0x0] = Math["max"](0x0, 0x1 - _0x126d3d);
        }
        return { morphTargets: _0xbb840e, influences: _0x2513ca };
      },
      _0x409a2b = (_0x1d0739, _0x147a63, _0x2816b4) => {
        const { morphTargets: _0x3b0c88, influences: _0x21ae71 } = _0x5d97c2(
          _0x1d0739,
          _0x147a63,
          _0x2816b4
        );
        if (!_0x3b0c88[0x0])
          throw new Error("morphTargets[0]\x20must\x20be\x20defined");
        const _0x4e4cff = new Float32Array(_0x3b0c88[0x0]["length"]);
        let _0x338e0f = new Vector3(),
          _0x301cfb = new Vector3();
        for (
          let _0x208172 = 0x0;
          _0x208172 < _0x3b0c88[0x0]["length"];
          _0x208172 += 0x3
        ) {
          _0x338e0f["set"](0x0, 0x0, 0x0);
          for (
            let _0xcca1fa = 0x0;
            _0xcca1fa < _0x3b0c88["length"];
            _0xcca1fa++
          ) {
            _0x301cfb["set"](
              _0x3b0c88[_0xcca1fa][_0x208172],
              _0x3b0c88[_0xcca1fa][_0x208172 + 0x1],
              _0x3b0c88[_0xcca1fa][_0x208172 + 0x2]
            ),
              _0x338e0f["addScaledVector"](_0x301cfb, _0x21ae71[_0xcca1fa]);
          }
          (_0x4e4cff[_0x208172] = _0x338e0f["x"]),
            (_0x4e4cff[_0x208172 + 0x1] = _0x338e0f["y"]),
            (_0x4e4cff[_0x208172 + 0x2] = _0x338e0f["z"]);
        }
        return _0x4e4cff;
      },
      _0x1a91fd = _0x409a2b(_0x534b2f, "position", _0x3ce96c),
      _0x286179 = _0x409a2b(_0x534b2f, "normal", _0x3ce96c);
    return { positions: _0x1a91fd, normals: _0x286179 };
  }
  static ["getPosedAttributes"](_0x531921, _0x4ea37b, _0xd8df5, _0x8c8b3) {
    let _0x290dd5 = (_0x124fe2, _0x21dbc1, _0xdac27e, _0x2399d1, _0x526e90) => {
        const _0x1d4c99 =
            _0x526e90 == "normal"
              ? new Matrix3()["setFromMatrix4"](_0xdac27e)
              : _0xdac27e,
          _0x2d8539 =
            _0x526e90 == "normal"
              ? new Matrix3()["setFromMatrix4"](_0x2399d1)
              : _0x2399d1,
          _0x187310 = [];
        for (
          let _0x2a7c81 = 0x0;
          _0x2a7c81 < _0x21dbc1["boneMatrices"]["length"] / 0x10;
          ++_0x2a7c81
        ) {
          let _0x168e32 = new Matrix4()["fromArray"](
            _0x21dbc1["boneMatrices"],
            0x10 * _0x2a7c81
          );
          _0x526e90 == "normal" &&
            (_0x168e32 = new Matrix3()["setFromMatrix4"](_0x168e32)),
            _0x187310["push"](_0x168e32);
        }
        const _0x5958f3 = _0x124fe2["getAttribute"]("skinIndex")["array"],
          _0x9b36c7 = _0x124fe2["getAttribute"]("skinWeight")["array"];
        let _0xba8bf3 = new Vector4(),
          _0x5468c5 = new Vector4(),
          _0x44c102 = new Vector3(),
          _0x3e8bde = new Vector3(),
          _0x2148ee = new Vector3(),
          _0x47b80a = _0x124fe2["getAttribute"](_0x526e90)["array"];
        const _0x34ee00 = new Float32Array(_0x47b80a["length"]);
        for (
          let _0x378877 = 0x0;
          _0x378877 < _0x47b80a["length"] / 0x3;
          _0x378877++
        ) {
          _0x44c102["fromArray"](_0x47b80a, _0x378877 * 0x3);
          _0x1d4c99 instanceof Matrix3
            ? _0x44c102["applyMatrix3"](_0x1d4c99)
            : _0x44c102["applyMatrix4"](_0x1d4c99);
          _0xba8bf3["fromArray"](_0x5958f3, _0x378877 * 0x4),
            _0x5468c5["fromArray"](_0x9b36c7, _0x378877 * 0x4),
            _0x3e8bde["set"](0x0, 0x0, 0x0);
          for (let _0x387332 = 0x0; _0x387332 < 0x4; _0x387332++) {
            const _0x4a2689 = _0xba8bf3["getComponent"](_0x387332),
              _0x2683de = _0x5468c5["getComponent"](_0x387332);
            if (_0x526e90 == "position")
              _0x2148ee["copy"](_0x44c102)["applyMatrix4"](
                _0x187310[_0x4a2689]
              );
            else
              _0x2148ee["copy"](_0x44c102)["applyMatrix3"](
                _0x187310[_0x4a2689]
              );
            _0x3e8bde["addScaledVector"](_0x2148ee, _0x2683de);
          }
          _0x2d8539 instanceof Matrix4
            ? _0x3e8bde["applyMatrix4"](_0x2d8539)
            : _0x3e8bde["applyMatrix3"](_0x2d8539),
            (_0x34ee00[0x3 * _0x378877] = _0x3e8bde["x"]),
            (_0x34ee00[0x3 * _0x378877 + 0x1] = _0x3e8bde["y"]),
            (_0x34ee00[0x3 * _0x378877 + 0x2] = _0x3e8bde["z"]);
        }
        return _0x34ee00;
      },
      _0x201196 = _0x290dd5(
        _0x531921,
        _0x4ea37b,
        _0xd8df5,
        _0x8c8b3,
        "position"
      ),
      _0x545a52 = _0x290dd5(_0x531921, _0x4ea37b, _0xd8df5, _0x8c8b3, "normal");
    return { positions: _0x201196, normals: _0x545a52 };
  }
  static ["flipSide"](_0xdf0ef6) {
    const _0x4f9b8d = _0xdf0ef6["getAttribute"]("position")?.["count"] || 0x0,
      _0x2fb3a4 = _0xdf0ef6["getAttribute"]("normal");
    if (_0x2fb3a4 !== undefined) {
      var _0x72bfc4 = new Vector3();
      for (var _0x2b8811 = 0x0; _0x2b8811 < _0x4f9b8d; ++_0x2b8811) {
        _0x72bfc4["set"](
          _0x2fb3a4["getX"](_0x2b8811),
          _0x2fb3a4["getY"](_0x2b8811),
          _0x2fb3a4["getZ"](_0x2b8811)
        ),
          _0x72bfc4["multiplyScalar"](-0x1),
          _0x2fb3a4["setXYZ"](
            _0x2b8811,
            _0x72bfc4["x"],
            _0x72bfc4["y"],
            _0x72bfc4["z"]
          );
      }
      _0x2fb3a4["needsUpdate"] = !![];
    }
    const _0x5a31fe = _0xdf0ef6["getIndex"]();
    if (_0x5a31fe) {
      const _0x4cf22c = _0x5a31fe["array"],
        _0x46e26f = _0x5a31fe["count"] / 0x3;
      for (var _0x2b8811 = 0x0; _0x2b8811 < _0x46e26f; _0x2b8811++) {
        var _0x4729b5 = _0x4cf22c[0x3 * _0x2b8811];
        _0x5a31fe["setX"](0x3 * _0x2b8811, _0x4cf22c[0x3 * _0x2b8811 + 0x2]),
          _0x5a31fe["setX"](0x3 * _0x2b8811 + 0x2, _0x4729b5);
      }
      _0x5a31fe["needsUpdate"] = !![];
    }
    return _0xdf0ef6;
  }
}
class OctreeMesh extends Mesh {
  ["raycastBoundingOnly"] = ![];
  ["raycast_max_level"] = -0x1;
  ["morphedGeometry"] = null;
  ["raycast"](_0x4214ea, _0xab6345) {
    return raycastOctreeMesh(
      this,
      this["morphedGeometry"] ?? this["geometry"],
      _0x4214ea,
      _0xab6345
    );
  }
  ["updateMorphedGeometryShape"]() {
    if (
      !this["morphTargetInfluences"] ||
      this["morphTargetInfluences"]["length"] == 0x0
    )
      return;
    else {
      if (!this["morphedGeometry"]) {
        this["morphedGeometry"] = new OctreeBufferGeometry()["copy"](
          this["geometry"]
        );
        for (let _0x7274e2 of Object["keys"](
          this["morphedGeometry"]["attributes"]
        )) {
          if (_0x7274e2 != "position" && _0x7274e2 != "normal")
            this["morphedGeometry"]["deleteAttribute"](_0x7274e2);
        }
      }
    }
    BufferGeometryUtils["setBufferAttributeArray"](
      this["morphedGeometry"],
      "position",
      this["geometry"]["getAttribute"]("position")["array"]
    ),
      BufferGeometryUtils["setBufferAttributeArray"](
        this["morphedGeometry"],
        "normal",
        this["geometry"]["getAttribute"]("normal")["array"]
      );
    if (
      this["morphTargetInfluences"] &&
      this["morphTargetInfluences"]["length"] > 0x0
    ) {
      const _0x3c822c = BufferGeometryUtils["getMorphedAttributes"](
        this["geometry"],
        this["morphTargetInfluences"]
      );
      BufferGeometryUtils["setBufferAttributeArray"](
        this["morphedGeometry"],
        "position",
        _0x3c822c["positions"]
      ),
        BufferGeometryUtils["setBufferAttributeArray"](
          this["morphedGeometry"],
          "normal",
          _0x3c822c["normals"]
        );
    }
    this["morphedGeometry"]["clearOctree"](),
      this["morphedGeometry"]["initializeOctree"]();
  }
}
class OctreeMeshSkinned extends SkinnedMesh {
  ["raycastBoundingOnly"] = ![];
  ["raycast_max_level"] = -0x1;
  #skinnedGeometry;
  constructor(_0x35f505, _0x36639c) {
    super(_0x35f505, _0x36639c),
      (this.#skinnedGeometry = new OctreeBufferGeometry()),
      _0x35f505 && this["constructSkinnedGeometry"]();
  }
  ["constructSkinnedGeometry"]() {
    if (!this.#skinnedGeometry)
      this.#skinnedGeometry = new OctreeBufferGeometry();
    this.#skinnedGeometry["copy"](this["geometry"]);
    for (let _0x375d89 of Object["keys"](this.#skinnedGeometry["attributes"])) {
      if (_0x375d89 != "position" && _0x375d89 != "normal")
        this.#skinnedGeometry["deleteAttribute"](_0x375d89);
    }
  }
  ["raycast"](_0x3716ca, _0x3dc4ca) {
    return raycastOctreeMesh(this, this.#skinnedGeometry, _0x3716ca, _0x3dc4ca);
  }
  ["getSkinnedGeometry"]() {
    return this.#skinnedGeometry;
  }
  ["updateSkinnedGeometry"]() {
    this["geometry"]
      ? this["constructSkinnedGeometry"]()
      : (this.#skinnedGeometry = new OctreeBufferGeometry());
  }
  ["updateSkinnedGeometryPose"]() {
    BufferGeometryUtils["setBufferAttributeArray"](
      this.#skinnedGeometry,
      "position",
      this["geometry"]["getAttribute"]("position")["array"]
    ),
      BufferGeometryUtils["setBufferAttributeArray"](
        this.#skinnedGeometry,
        "normal",
        this["geometry"]["getAttribute"]("normal")["array"]
      );
    if (
      this["morphTargetInfluences"] &&
      this["morphTargetInfluences"]["length"] > 0x0
    ) {
      const _0x3ee5fb = BufferGeometryUtils["getMorphedAttributes"](
        this["geometry"],
        this["morphTargetInfluences"]
      );
      BufferGeometryUtils["setBufferAttributeArray"](
        this.#skinnedGeometry,
        "position",
        _0x3ee5fb["positions"]
      ),
        BufferGeometryUtils["setBufferAttributeArray"](
          this.#skinnedGeometry,
          "normal",
          _0x3ee5fb["normals"]
        );
    }
    if (this["skeleton"] && this["bindMatrix"] && this["bindMatrixInverse"]) {
      const _0xa13174 = BufferGeometryUtils["getPosedAttributes"](
        this["geometry"],
        this["skeleton"],
        this["bindMatrix"],
        this["bindMatrixInverse"]
      );
      BufferGeometryUtils["setBufferAttributeArray"](
        this.#skinnedGeometry,
        "position",
        _0xa13174["positions"]
      ),
        BufferGeometryUtils["setBufferAttributeArray"](
          this.#skinnedGeometry,
          "normal",
          _0xa13174["normals"]
        );
    }
    this.#skinnedGeometry["clearOctree"](),
      this.#skinnedGeometry["initializeOctree"]();
  }
}
function pointHash(_0x143824) {
  return (
    _0x143824["x"]["toFixed"](0x7) +
    "," +
    _0x143824["y"]["toFixed"](0x7) +
    "," +
    _0x143824["z"]["toFixed"](0x7)
  );
}
function vertexSphereSelection(
  _0x306ef0,
  _0xb285b9,
  _0x2c0123,
  _0x57959d,
  _0x5c18b7 = 0x1
) {
  let _0x522bbe = new Map(),
    _0xd932ae = new Set(),
    _0x2a3f16 = new Sphere(_0x2c0123["clone"](), _0x57959d),
    _0x4f3eda = _0x306ef0["getAttribute"]("position");
  const _0x2cdbb9 = _0xb285b9["clone"]()["invert"]();
  _0x2a3f16["applyMatrix4"](_0x2cdbb9);
  let _0x265519 = new Vector3(),
    _0x56487d = new Vector3(),
    _0x339080 = new Vector3(),
    _0x1eb519 = function (_0x2d0d6c) {
      if (!_0x2d0d6c) return;
      if (!_0x2d0d6c["intersectsSphere"](_0x2a3f16)) return;
      let _0x170061 = 0x0,
        _0x157aa5 = 0x0,
        _0x3f4baf = 0x0,
        _0x163f44 = new Array();
      if (_0x2d0d6c["data"] && _0x2d0d6c["data"]["length"] > 0x0)
        for (let _0x127733 of _0x2d0d6c["data"]) {
          !_0xd932ae["has"](_0x127733) &&
            (_0x163f44["push"](_0x127733), _0xd932ae["add"](_0x127733));
        }
      for (let _0x4428b1 of _0x163f44) {
        _0x306ef0["index"]
          ? ((_0x170061 = _0x306ef0["index"]["getX"](_0x4428b1 * 0x3)),
            (_0x157aa5 = _0x306ef0["index"]["getX"](_0x4428b1 * 0x3 + 0x1)),
            (_0x3f4baf = _0x306ef0["index"]["getX"](_0x4428b1 * 0x3 + 0x2)))
          : ((_0x170061 = _0x4428b1 * 0x3),
            (_0x157aa5 = _0x4428b1 * 0x3 + 0x1),
            (_0x3f4baf = _0x4428b1 * 0x3 + 0x2));
        _0x265519["fromBufferAttribute"](_0x4f3eda, _0x170061),
          _0x56487d["fromBufferAttribute"](_0x4f3eda, _0x157aa5),
          _0x339080["fromBufferAttribute"](_0x4f3eda, _0x3f4baf);
        let _0x3bd9f1 = _0x2a3f16["distanceToPoint"](_0x265519);
        _0x3bd9f1 <= 0x0 &&
          !_0x522bbe["has"](_0x170061) &&
          _0x522bbe["set"](_0x170061, {
            position: _0x265519,
            alpha: Math["pow"](-_0x3bd9f1 / _0x57959d, 0x1 - _0x5c18b7)
          });
        let _0x43fdb2 = _0x2a3f16["distanceToPoint"](_0x56487d);
        _0x43fdb2 <= 0x0 &&
          !_0x522bbe["has"](_0x157aa5) &&
          _0x522bbe["set"](_0x157aa5, {
            position: _0x56487d,
            alpha: Math["pow"](-_0x43fdb2 / _0x57959d, 0x1 - _0x5c18b7)
          });
        let _0x1f2e5f = _0x2a3f16["distanceToPoint"](_0x339080);
        _0x1f2e5f <= 0x0 &&
          !_0x522bbe["has"](_0x3f4baf) &&
          _0x522bbe["set"](_0x3f4baf, {
            position: _0x339080,
            alpha: Math["pow"](-_0x1f2e5f / _0x57959d, 0x1 - _0x5c18b7)
          });
      }
      if (_0x2d0d6c["children"] && _0x2d0d6c["children"]["length"] > 0x0)
        for (let _0x30b940 of _0x2d0d6c["children"]) {
          _0x1eb519(_0x30b940);
        }
    };
  return _0x1eb519(_0x306ef0["octree"]), _0x522bbe;
}
class VertexSelector {
  ["vertexSelection"];
  #geometry;
  #matrixTransform;
  constructor() {
    (this["vertexSelection"] = new Map()),
      (this.#geometry = null),
      (this.#matrixTransform = new Matrix4());
  }
  ["setGeometry"](_0x2a812b) {
    (this.#geometry = _0x2a812b), this["resetSelection"]();
  }
  ["setMatrixTransform"](_0x155726) {
    this.#matrixTransform = _0x155726;
  }
  ["isMeshSet"]() {
    return this.#geometry != null;
  }
  ["getSelection"]() {
    return this["vertexSelection"];
  }
  ["selectAll"]() {
    this["resetSelection"]();
    if (this.#geometry) {
      let _0x3c26b8 = this.#geometry["getAttribute"]("position"),
        _0x51b060 = new Vector3();
      for (let _0x4e486d = 0x0; _0x4e486d < _0x3c26b8["count"]; ++_0x4e486d) {
        _0x51b060["fromBufferAttribute"](_0x3c26b8, _0x4e486d),
          this["vertexSelection"]["set"](_0x4e486d, {
            position: _0x51b060,
            alpha: 0x1
          });
      }
    }
  }
  static ["getSelectAll"](_0x286187) {
    let _0x436f0f = _0x286187["getAttribute"]("position"),
      _0x2396eb = new Map(),
      _0x46db4d = new Vector3();
    for (let _0x393ae0 = 0x0; _0x393ae0 < _0x436f0f["count"]; ++_0x393ae0) {
      _0x46db4d["fromBufferAttribute"](_0x436f0f, _0x393ae0),
        _0x2396eb["set"](_0x393ae0, { position: _0x46db4d, alpha: 0x1 });
    }
    return _0x2396eb;
  }
  ["addSphereToSelection"](_0x425bd2, _0xa737c = !![]) {
    let _0x1d6380 = _0x425bd2["center"],
      _0x26446c = _0x425bd2["radius"],
      _0x1682ea = _0x425bd2["hardness"],
      _0x1b5741 = vertexSphereSelection(
        this.#geometry,
        this.#matrixTransform,
        _0x1d6380,
        _0x26446c,
        _0x1682ea
      );
    for (let [_0xf07c26, _0x15bfe4] of _0x1b5741) {
      this["vertexSelection"]["has"](_0xf07c26)
        ? (this["vertexSelection"]["get"](_0xf07c26)["alpha"] = Math["min"](
            0x1,
            _0xa737c
              ? this["vertexSelection"]["get"](_0xf07c26)["alpha"] +
                  _0x15bfe4["alpha"]
              : Math["max"](
                  this["vertexSelection"]["get"](_0xf07c26)["alpha"],
                  _0x15bfe4["alpha"]
                )
          ))
        : this["vertexSelection"]["set"](_0xf07c26, _0x15bfe4);
    }
  }
  ["isSelectionEmpty"]() {
    return this["vertexSelection"]["size"] == 0x0;
  }
  ["substractSphereToSelection"](_0x13dc5b) {
    let _0x227a11 = _0x13dc5b["center"],
      _0x1a87c0 = _0x13dc5b["radius"],
      _0x9358b4 = vertexSphereSelection(
        this.#geometry,
        this.#matrixTransform,
        _0x227a11,
        _0x1a87c0
      );
    for (let [_0x57ddf4, _0x14305e] of _0x9358b4) {
      this["vertexSelection"]["has"](_0x57ddf4) &&
        this["vertexSelection"]["delete"](_0x57ddf4);
    }
  }
  ["resetSelection"]() {
    this["vertexSelection"] = new Map();
  }
}
function FloatTextureSupport(_0x231dd6) {
  if (_0x231dd6)
    return (
      _0x231dd6["getContext"]()["getExtension"]("EXT_color_buffer_float") ||
      _0x231dd6["getContext"]()["getExtension"]("OES_texture_float")
    );
  else {
    let _0x23ddce = document["getElementsByTagName"]("canvas"),
      _0x5ea774 = null,
      _0x4a6411 = ![];
    if (_0x23ddce["length"] == 0x0)
      (_0x5ea774 = document["createElement"]("canvas")), (_0x4a6411 = !![]);
    else {
      for (let _0x41d0f9 = 0x0; _0x41d0f9 < _0x23ddce["length"]; ++_0x41d0f9) {
        if (
          _0x23ddce[_0x41d0f9]["getContext"]("webgl2") ||
          _0x23ddce[_0x41d0f9]["getContext"]("webgl")
        ) {
          _0x5ea774 = _0x23ddce["item"](_0x41d0f9);
          break;
        }
      }
      if (!_0x5ea774)
        throw "FloatTextureLinearFilterSupport:\x20fatal\x20error,\x20no\x20webgl\x20context\x20available";
    }
    let _0x570f52 =
      _0x5ea774["getContext"]("webgl2") ?? _0x5ea774["getContext"]("webgl");
    if (_0x570f52) {
      let _0x27496e = _0x570f52["getExtension"]("EXT_color_buffer_float");
      if (_0x4a6411) _0x5ea774["remove"]();
      return _0x27496e;
    } else {
      _0x570f52 = _0x5ea774["getContext"]("webgl");
      if (_0x570f52) {
        let _0x4aec34 = _0x570f52["getExtension"]("OES_texture_float");
        if (_0x4a6411) _0x5ea774["remove"]();
        return _0x4aec34;
      } else
        throw "FloatTextureSupport:\x20fatal\x20error,\x20no\x20webgl\x20context\x20available";
    }
  }
}
function FloatTextureLinearFilterSupport(_0x15bda7) {
  if (_0x15bda7)
    return _0x15bda7["getContext"]()["getExtension"](
      "OES_texture_float_linear"
    );
  else {
    let _0x5d4595 = document["getElementsByTagName"]("canvas"),
      _0x5f5c8 = null,
      _0x2fff4a = ![];
    if (_0x5d4595["length"] == 0x0)
      (_0x5f5c8 = document["createElement"]("canvas")), (_0x2fff4a = !![]);
    else {
      for (let _0x33adff = 0x0; _0x33adff < _0x5d4595["length"]; ++_0x33adff) {
        if (
          _0x5d4595[_0x33adff]["getContext"]("webgl2") ||
          _0x5d4595[_0x33adff]["getContext"]("webgl")
        ) {
          _0x5f5c8 = _0x5d4595["item"](_0x33adff);
          break;
        }
      }
      if (!_0x5f5c8)
        throw "FloatTextureLinearFilterSupport:\x20fatal\x20error,\x20no\x20webgl\x20context\x20available";
    }
    let _0x554c8b =
      _0x5f5c8["getContext"]("webgl2") ?? _0x5f5c8["getContext"]("webgl");
    if (_0x554c8b) {
      let _0x3b90cb = _0x554c8b["getExtension"]("OES_texture_float_linear");
      if (_0x2fff4a) _0x5f5c8["remove"]();
      return _0x3b90cb;
    } else
      throw "FloatTextureLinearFilterSupport:\x20fatal\x20error,\x20no\x20webgl\x20context\x20available";
  }
}
const PolylineUtils = {
  closestPointToPoint: (function () {
    const _0x14bbac = new Vector3(),
      _0x217306 = new Line3();
    return function (_0x45a54b, _0x4fb8bd, _0x56ab14) {
      var _0xc86f15 = Number["MAX_VALUE"];
      for (
        var _0x90130d = 0x0;
        _0x90130d < _0x45a54b["length"] - 0x1;
        ++_0x90130d
      ) {
        _0x217306["start"]["copy"](_0x45a54b[_0x90130d]),
          _0x217306["end"]["copy"](_0x45a54b[_0x90130d + 0x1]),
          _0x217306["closestPointToPoint"](_0x4fb8bd, !![], _0x14bbac);
        var _0x11bce1 = _0x14bbac["sub"](_0x4fb8bd)["lengthSq"]();
        _0x11bce1 < _0xc86f15 &&
          (_0x56ab14["copy"](_0x14bbac)["add"](_0x4fb8bd),
          (_0xc86f15 = _0x11bce1));
      }
      return _0x56ab14;
    };
  })(),
  distanceToPoint: (function () {
    const _0x1e3786 = new Vector3();
    return function (_0x48082d, _0x2dd902) {
      return PolylineUtils["closestPointToPoint"](
        _0x48082d,
        _0x2dd902,
        _0x1e3786
      )
        ["sub"](_0x2dd902)
        ["length"]();
    };
  })(),
  length: function (_0x9c0d03) {
    var _0x4d6a9a = 0x0,
      _0x442502 = new Vector3();
    for (
      var _0x4159e4 = 0x0;
      _0x4159e4 < _0x9c0d03["length"] - 0x1;
      ++_0x4159e4
    ) {
      _0x442502["subVectors"](_0x9c0d03[_0x4159e4], _0x9c0d03[_0x4159e4 + 0x1]),
        (_0x4d6a9a += _0x442502["length"]());
    }
    return _0x4d6a9a;
  }
};
export {
  BufferAttributeSerializer,
  BufferGeometryComputations,
  BufferGeometrySerializer,
  BufferGeometryUtils,
  FloatTextureLinearFilterSupport,
  FloatTextureSupport,
  MeshWireframeMaterial,
  OBJMTLExporter,
  OctreeBufferGeometry,
  OctreeBufferGeometrySerializer,
  OctreeMesh,
  OctreeMeshSkinned,
  PolylineUtils,
  VertexSelector,
  approximateMultiMeshVolume,
  getCameraRay,
  getObjectsIntersections,
  pointHash,
  raycastOctreeMesh,
  resizeArrayBuffer,
  vertexSphereSelection
};
